let productType = '';

let inchWidth = '';
let inchHeight = '';
// Acrylic initialization user selected size
let acrylicInchWidth = '';
let acrylicInchHeight = '';
let inchSourceWidth = '';
let inchSourceHeight = '';
let drawImageUrl = '';
let imgFactWidth = '';
let imgFactHeight = '';
let uniqueId = '';
let lineType = '';
let circlesticker = 'rightRect';
let canvasSource;
let bleedLineWidth = 2;
// mm
let workAreaWidth =  '';
let workAreaHeight =  '';
let diyWorkAreaWidth =  0;
let diyWorkAreaHeight =  465;
let canvasInitSize = 465;
if (window.document.body.clientWidth < 1500){
    canvasInitSize = 400;
}

let secondBleedWidth = ''; // Bleeding distance
let secondBleedHeight = ''
let imagePaddingWidth = ''; // Image safety distance

// Image operation re
let reloadImgObjs = {
    nocropImg:'',
    noclearImg:''
}

let undoObjArr = [];
let redoObjArr = [];

let currentImgObj = ''; // The only image on the canvas
let startDieCutFlag = false; // Do you want to enable custom tangent lines
// extractDieCutLine Rusult
dieCutResultData = {
    data: null,
    clearData: null
}

/**************** customer operation records start ********************/
let recordsParentId = '';
let optstep = 1;
let saveRecordsFlag=true;

let customerOpearationRecords = function(recordsParentId, optbtn, optstep){
    if(recordsParentId){
        // debugger
        let data = {
            parentid:recordsParentId,
            optbtn:optbtn,
            optstep:optstep
        };
        $.ajax({
            url: "https://diy.racetopprint.com/diyWeb/csrdiy/customerOperationRecords.do",
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function(res) {
                if (res.success) {

                }
            },
            error: function(error) {

            }
        });
    }
}

/**************** customer operation records end ********************/

/************** bleed line start *******************/
let drawBleedRightLine = function (needDrawLine, bleedLineWidth, shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis) {
    if(needDrawLine){
        var secondABarr, secondCDarr;
        secondABarr = [shadeLeftWidth, shadeTopHeight, shadeLeftWidth, canvasSource.getHeight() - secondBottomHeight - bleedLineWidth];
        secondCDarr = [canvasSource.getWidth() - shadeLeftWidth - bleedLineWidth, shadeTopHeight, canvasSource.getWidth() - shadeLeftWidth - bleedLineWidth, canvasSource.getHeight() - secondBottomHeight - bleedLineWidth];
        secondABLine = new fabric.Line(secondABarr, {
            strokeDashArray: [0, 0],
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        secondCDLine = new fabric.Line(secondCDarr, {
            strokeDashArray: [0, 0],
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        secondABLine.objType='bleedLine';
        secondCDLine.objType='bleedLine';
        canvasSource.add(secondABLine);
        canvasSource.add(secondCDLine);

        var secondACarr, secondBDarr;
        secondACarr = [shadeLeftWidth,shadeTopHeight,canvasSource.getWidth()-shadeRightWidth-bleedLineWidth,shadeTopHeight];
        secondBDarr = [shadeLeftWidth,canvasSource.getHeight()-shadeTopHeight-bleedLineWidth,canvasSource.getWidth()-shadeRightWidth+bleedLineWidth,canvasSource.getHeight()-shadeTopHeight-bleedLineWidth];
        secondACLine = new fabric.Line(secondACarr, {
            strokeDashArray: [0, 0],
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        secondBDLine = new fabric.Line(secondBDarr, {
            strokeDashArray: [0, 0],
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        secondACLine.objType='bleedLine';
        secondBDLine.objType='bleedLine';
        canvasSource.add(secondACLine);
        canvasSource.add(secondBDLine);

        canvasSource.renderAll();
    }
    stickerBorderShade(needDrawLine, 'square-right', shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis);
}

let drawBleedCircleLine = function (needDrawLine, bleedLineWidth, shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis) {
    if(needDrawLine){
        let filletRadius = 5 * 3.79;
        ABStr = "M " + Number(shadeLeftWidth + filletRadius) + " " + Number(shadeTopHeight) + " L " + Number(canvasSource.getWidth() - shadeLeftWidth - filletRadius) + " " + Number(shadeTopHeight) + " Q " + Number(canvasSource.getWidth() - shadeRightWidth) + " " + Number(secondBottomHeight) + " " + Number(canvasSource.getWidth() - shadeRightWidth) + " " + Number(secondBottomHeight + filletRadius)
        CDStr = "M " + Number(canvasSource.getWidth() - shadeTopHeight - filletRadius) + " " + Number(canvasSource.getHeight() - shadeTopHeight) + " L " + Number(shadeLeftWidth + filletRadius) + " " + Number(canvasSource.getHeight() - shadeLeftWidth) + " Q " + Number(shadeRightWidth + bleedLineWidth) + " " + Number(canvasSource.getHeight() - shadeRightWidth) + " " + Number(shadeRightWidth) + " " + Number(canvasSource.getHeight() - secondBottomHeight - filletRadius)


        BCStr = "M " + Number(canvasSource.getWidth() - shadeLeftWidth) + " " + Number(shadeTopHeight + filletRadius) + " L " + Number(canvasSource.getWidth() - shadeLeftWidth) + " " + Number(canvasSource.getHeight() - shadeLeftWidth - filletRadius) + " Q " + Number(canvasSource.getWidth() - shadeRightWidth) + " " + Number(canvasSource.getHeight() - secondBottomHeight) + " " + Number(canvasSource.getWidth() - secondBottomHeight - filletRadius) + " " + Number(canvasSource.getHeight() - secondBottomHeight)
        DAStr = "M " + Number(shadeLeftWidth) + " " + Number(canvasSource.getHeight() - shadeTopHeight - filletRadius) + " L " + Number(shadeLeftWidth) + " " + Number(shadeTopHeight + filletRadius) + " Q " + Number(shadeRightWidth) + " " + Number(secondBottomHeight) + " " + (shadeRightWidth + filletRadius) + " " + Number(secondBottomHeight)

        var zbAB = ABStr;
        var zbBC = BCStr
        var zbCD = CDStr
        var zbDA = DAStr;
        var circleLineAB = new fabric.Path(zbAB, {
            strokeDashArray: [0, 0],
            fill: '',
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        var circleLineBC = new fabric.Path(zbBC, {
            strokeDashArray: [0, 0],
            fill: '',
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        var circleLineCD = new fabric.Path(zbCD, {
            strokeDashArray: [0, 0],
            fill: '',
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        var circleLineDA = new fabric.Path(zbDA, {
            strokeDashArray: [0, 0],
            fill: '',
            stroke: 'red',
            strokeWidth: 2,
            selectable: false
        });
        circleLineAB.objType = circleLineBC.objType = circleLineCD.objType = circleLineDA.objType = 'bleedLine';
        canvasSource.add(circleLineAB);
        canvasSource.add(circleLineBC);
        canvasSource.add(circleLineCD);
        canvasSource.add(circleLineDA);
        canvasSource.renderAll();
    }
    stickerBorderShade(needDrawLine, 'square-circle', shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis)
}

let drawBleedEllipseLine = function (needDrawLine, shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis) {
    stickerBorderShade(needDrawLine, 'ellipse', shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis);
}

let stickerBorderShade = function (needDrawLine, type, shadeLeftWidth, shadeTopHeight, shadeRightWidth, secondBottomHeight, saveHis) {
    $('#stickerCanvas').remove();
    $('body').append('<canvas style="display:none;" id="stickerCanvas" ></canvas>');
    $('#stickerCanvas')[0].width = canvasSource.getWidth();
    $('#stickerCanvas')[0].height = canvasSource.getHeight();
    var stickerCanvas = document.getElementById("stickerCanvas");
    var stickerContext = stickerCanvas.getContext('2d');
    if(needDrawLine){
        stickerContext.globalAlpha = 1;
    }else{
        stickerContext.globalAlpha = 0.6;
    }
    stickerContext.clearRect(0, 0, canvasSource.getWidth(), canvasSource.getHeight());
    stickerContext.rect(0, 0, stickerCanvas.width, stickerCanvas.height);
    stickerContext.fillStyle = "#F5F5F5"
    stickerContext.fill();
    if (type == 'circle' || type == 'square-circle' ) {
        let filletRadius = 5 * 3.79;
        if (type == 'circle') {
            filletRadius = 100;
            var rotaDouble = (90 / 2) * Math.PI / 180;
            var sinRota = Math.sin(rotaDouble);
            filletRadius = Math.pow(filletRadius * sinRota, 2);
            stickerContext.globalCompositeOperation = "destination-out";
            if(needDrawLine){
                stickerContext.globalAlpha = 1;
            }else{
                stickerContext.globalAlpha = 0.6;
            }
            // roundRect(stickerContext, 0, 0, canvasSource.getWidth() - bleedLineWidth * 2, canvasSource.getHeight() - bleedLineWidth * 2, filletRadius).stroke();
            roundRect(stickerContext, shadeLeftWidth, shadeTopHeight, canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth), canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight), filletRadius).stroke();

            stickerContext.globalCompositeOperation = "destination-over";
            stickerContext.beginPath();
            stickerContext.globalAlpha = 1;
            stickerContext.lineWidth = 2;
            stickerContext.strokeStyle = 'red';
            stickerContext.arc(canvasSource.getWidth() / 2, canvasSource.getHeight() / 2, (canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth)) / 2, 0, Math.PI * 2, true); //
            stickerContext.closePath();
            stickerContext.stroke();
            stickerContext.fill();
        }
        stickerContext.globalCompositeOperation = "destination-out";
        stickerContext.globalAlpha = 1;
        if (type == 'circle') {
            if(needDrawLine){
                roundRect(stickerContext, shadeLeftWidth + 2, shadeTopHeight + 2, canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth) - 4, canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight) - 4, filletRadius).stroke();
            }else{
                roundRect(stickerContext, shadeLeftWidth, shadeTopHeight, canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth), canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight), filletRadius).stroke();
            }
        } else {
            roundRect(stickerContext, shadeLeftWidth, shadeTopHeight, canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth), canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight), filletRadius).stroke();
        }
    } else if(type == 'square-right'){
        stickerContext.beginPath();
        stickerContext.fillStyle = "red";
        stickerContext.globalAlpha = 1;
        stickerContext.globalCompositeOperation = "destination-out";
        stickerContext.fillRect(shadeLeftWidth, shadeTopHeight, canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth), canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight));
        stickerContext.closePath();
    }else{
        stickerContext.globalCompositeOperation = "source-over";
        stickerContext.beginPath();
        if(needDrawLine){
            stickerContext.globalAlpha = 1;
        }else{
            stickerContext.globalAlpha = 0.6;
        }
        stickerContext.strokeStyle = 'red';
        stickerContext.ellipse(canvasSource.getWidth() / 2, canvasSource.getHeight() / 2, (canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth)) / 2, (canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight)) / 2, 0, 0, Math.PI * 2)
        stickerContext.closePath();
        stickerContext.fill();
        stickerContext.stroke();


        stickerContext.beginPath();
        stickerContext.globalAlpha = 1;
        stickerContext.fillStyle = "red";
        stickerContext.globalCompositeOperation = "destination-out";
        if(needDrawLine){
            stickerContext.ellipse(canvasSource.getWidth() / 2, canvasSource.getHeight() / 2, (canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth)) / 2 - 2, (canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight)) / 2 - 2, 0, 0, Math.PI * 2)
        }else{
            stickerContext.ellipse(canvasSource.getWidth() / 2, canvasSource.getHeight() / 2, (canvasSource.getWidth() - (shadeLeftWidth + shadeRightWidth)) / 2, (canvasSource.getHeight() - (shadeTopHeight + secondBottomHeight)) / 2, 0, 0, Math.PI * 2)
        }
        stickerContext.fill();
        stickerContext.stroke();
    }
    var dataURL = stickerCanvas.toDataURL({format: 'png'});
    var that = this;
    fabric.Image.fromURL(dataURL, function (Img) {
        Img.isBleedShape=true;
        canvasSource.setOverlayImage(Img, function () {
            if(saveHis){
                for (let index = 0; index < canvasSource._objects.length; index++) {
                    if(canvasSource._objects[index].objType == 'draggableDiecut'){
                        let cutAreaHis = {
                            lineType:type,
                            shadeLeftWidth: shadeLeftWidth,
                            shadeTopHeight: shadeTopHeight,
                            shadeRightWidth: shadeRightWidth,
                            secondBottomHeight: secondBottomHeight,
                            dragLet: canvasSource._objects[index].left,
                            dragTop: canvasSource._objects[index].top,
                            dragScaleX: canvasSource._objects[index].scaleX,
                            dragScaleY: canvasSource._objects[index].scaleY,
                        }
                        let undoObj = {
                            // canvasObj: canvasSource.toJSON(),
                            cutAreaObj: cutAreaHis
                        }
                        undoObjArr.unshift(undoObj);
                        $('.uploadPropTipDiy .Undo').css('display','block');
                    }
                }
            }
            canvasSource.requestRenderAll();
            // that.setCanvasURL();
        }, {	  //opacity:0.5,
            originX: 'left',
            originY: 'top',
            width: canvasSource.getWidth(),
            height: canvasSource.getHeight(),
            selectable: false
        })

    })
}

var roundRect = function (context, x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    context.beginPath();
    context.moveTo(x + r, y);
    context.arcTo(x + w, y, x + w, y + h, r);
    context.arcTo(x + w, y + h, x, y + h, r);
    context.arcTo(x, y + h, x, y, r);
    context.arcTo(x, y, x + w, y, r);
    context.closePath();
    context.fillStyle = "green";
    context.fill();
    return context;
}

let setDemension = function(){
    if($('.demension-h').length == 0){
        $(".canvas-container").append('<div class="demension-h" id="widtho"  style="width:' + (canvasSource.getWidth() - secondBleedWidth * 2) + 'px;left:'+secondBleedWidth+'px;">' +
            '<div class="line"></div>' +
            '<div class="text">' + inchWidth + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
        $(".canvas-container").append('<div class="demension-v"  id="heightv"  style="height:' + (canvasSource.getHeight() - secondBleedHeight * 2) + 'px;top:'+secondBleedHeight+'px;">' +
            '<div class="line"></div>' +
            '<div class="text">' +  inchHeight + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
    }
}

/************** bleed line end *******************/

//Get preview image
let getPreviewImageFun=function(name) {
    let reName=name;
    $.ajax({
        url: window.locaUrlDiy + "/diyWeb/diy/findBackGroundByName.do",
        type: "POST",
        data: {
            name: reName
        },
        success: function (res) {
            if (res.success) {
                if (res.userData && res.userData.length > 0) {
                    $.each(res.userData, function (index, item) {
                        let url=window.locaUrlDiy + "/diyWeb/assets/resource/imgs/normal/" + item.url;
                        $(".sticker-preview .preview-img").attr("src",url);
                    });
                }
            }
        },
        error: function (error) {},
    });
}

// set canva size
let setCanvasSize=function (scaleWidth, scaleHeight, size) {
    canvasSource.setWidth(scaleWidth);
    canvasSource.setHeight(scaleHeight);
    canvasSource.setZoom(size);
}

let setCanvasBgColor=function(imagePath){
    // set canvas background
    let imageee = new Image();
    imageee.src = imagePath;
    imageee.crossOrigin = 'Anonymous';
    imageee.onload = function () {
        let isAlphaBackground = false;
        let c = document.createElement("canvas");
        c.width = this.width;
        c.height = this.height;
        let ctx = c.getContext("2d");
        ctx.drawImage(imageee, 0, 0);
        let imageData = ctx.getImageData(0, 0, this.width, this.height).data;
        for (let index = 3; index < imageData.length; index += 4) {
            if (imageData[index] != 255) {
                isAlphaBackground = true;
                break;
            }
        }
        if(!isAlphaBackground){
            let tl = Array.prototype.slice.call(ctx.getImageData(0, 0, 1, 1).data);
            let tm = Array.prototype.slice.call(ctx.getImageData(this.width / 2, 0, 1, 1).data);
            let tr = Array.prototype.slice.call(ctx.getImageData(this.width - 1, 0, 1, 1).data);
            let rm = Array.prototype.slice.call(ctx.getImageData(this.width - 1, this.height / 2, 1, 1).data);
            let br = Array.prototype.slice.call(ctx.getImageData(this.width - 1, this.height - 1, 1, 1).data);
            let bm = Array.prototype.slice.call(ctx.getImageData(this.width / 2, this.height -1, 1, 1).data);
            let bl = Array.prototype.slice.call(ctx.getImageData(0, this.height - 1, 1, 1).data);
            let lm = Array.prototype.slice.call(ctx.getImageData(0, this.height / 2, 1, 1).data);
            let simColorFlag = false;
            if(tl[0] == tm[0] && tl[0] == tr[0] && tl[0] == rm[0] && tl[0] == br[0] && tl[0] == bm[0] && tl[0] == bl[0] && tl[0] == lm[0] &&
                tl[1] == tm[1] && tl[1] == tr[1] && tl[1] == rm[1] && tl[1] == br[1] && tl[1] == bm[1] && tl[1] == bl[1] && tl[1] == lm[1] &&
                tl[2] == tm[2] && tl[2] == tr[2] && tl[2] == rm[2] && tl[2] == br[2] && tl[2] == bm[2] && tl[2] == bl[2] && tl[2] == lm[2]){
                simColorFlag = true;
            }
            if(simColorFlag){
                let rgbColor = "rgb("+tl[0]+ "," + tl[1] + "," + tl[2] + ")";
                canvasSource.setBackgroundColor(colorHex(rgbColor));
            }
        }
    }
}
function btnShowOrHide(show, showClearer) {
    if(show) {
        $('.uploadPropTipDiyDivLeft .start-draw-diecut').css('display','block');
        $('.uploadPropTipDiyDivLeft .sure-draw-diecut').css('display','block');
        $('.uploadPropTipDiyDivLeft .img-btn-box .remove-background').css('display','flex');
        $('.uploadPropTipDiyDivLeft .img-btn-box .become-clearer').css('display','flex');
        $('.uploadPropTipDiyDivLeft .img-btn-boxbu').css('display','flex');
    } else {
        $('.uploadPropTipDiyDivLeft .start-draw-diecut').css('display','none');
        $('.uploadPropTipDiyDivLeft .sure-draw-diecut').css('display','none');
        $('.uploadPropTipDiyDivLeft .img-btn-box .remove-background').css('display','none');
        if(showClearer){
            $('.uploadPropTipDiyDivLeft .img-btn-box .become-clearer').css('display','flex');
        } else {
            $('.uploadPropTipDiyDivLeft .img-btn-box .become-clearer').css('display','none');
        }
        $('.uploadPropTipDiyDivLeft .img-btn-boxbu').css('display','none');
        $('.uploadPropTipDiyDivLeft .Undo').css('display','none');
    }
}
/************** canvas init *******************/
function initCanvas(a, b, c, d, e, f, g, h, redrawing, imgOffsetLeft, imgOffsetTop, imageWidth, imageHeight, dieCutWidth, dieCutHeight){
    $(".page-width .paper-handbag-Diy").remove();
    btnShowOrHide(true)
    inchWidth = a;
    inchHeight = b;
    inchSourceWidth = inchWidth;
    inchSourceHeight = inchHeight;
    drawImageUrl = c;
    imgFactWidth = d;
    imgFactHeight = e;
    // if(imgFactWidth >= 2000 || imgFactHeight>= 2000){
    //     $('.become-clearer').css('display','none');
    // }else{
    //     $('.become-clearer').css('display','flex');
    // }
    uniqueId = f;
    lineType = g;
    let bleedBase = 3;
    // mm
    workAreaWidth =  Math.round(inchWidth*25.4+7);
    workAreaHeight =  Math.round(inchHeight*25.4+7);
    if(h && h != '' && h != 'sticker'){
        productType = h.replace(/\s+/g, "");
        if(productType == 'WallDecal' || productType == 'FloorDecals' || productType == 'Decal'){
            //Get Scence preview image
            getPreviewImageFun(productType);
            $(".uploadPropTipDiyDivLeft .previewDecal").css('display','block');
        }
        bleedBase = 1.5;
    }else{
        productType = 'sticker';
        if($('.product__titleh1').text().indexOf('sticker') == -1 && $('.product__titleh1').text().indexOf('Stickers') == -1){
            productType = '';
            // mm
            workAreaWidth =  Math.round(inchWidth*25.4+4);
            workAreaHeight =  Math.round(inchHeight*25.4+4);
        }
    }
    $(".sticker-preview-preview").parents(".uploadPropTipDiy").addClass('dialog-' + productType);
    $('.cartreloads').find('p').text('Loading your design...');
    $('.cartreloads').css('display','block');
    /************ Canvas diy start ****************/

    if (window.document.body.clientWidth < 750){
        diyWorkAreaWidth = $(window).width() * 0.95 - 80;
        diyWorkAreaHeight = diyWorkAreaWidth
    }else{
        diyWorkAreaWidth = canvasInitSize;
        diyWorkAreaHeight = canvasInitSize;
    }

    let data = {
        uniqueId:uniqueId,
        productname:'sticker'
    };
    $.ajax({
        url: "https://diy.racetopprint.com/diyWeb/csrdiy/customerOperationRecords.do",
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function(res) {
            if (res.success) {
                recordsParentId = res.userData;
            }
        },
        error: function(error) {

        }
    });

    let canvasId = 'cas-res';
    var existingCanvas = document.getElementById(canvasId);
    if (!existingCanvas) {
        $('.uploadPropTipDiy .can-resource').append('<canvas id="cas-res" ></canvas>');
        canvasSource = new fabric.Canvas(canvasId);
    } else {
        canvasSource = new fabric.Canvas(existingCanvas);
        canvasSource.clear();
    }
    canvasSource.preserveObjectStacking = true;

    let canvasScale = 1;
    if(workAreaWidth > workAreaHeight){
        canvasScale = diyWorkAreaWidth / workAreaWidth;
        diyWorkAreaHeight = workAreaHeight * canvasScale;
    }else{
        canvasScale = diyWorkAreaHeight / workAreaHeight;
        diyWorkAreaWidth = workAreaWidth * canvasScale;
    }
    // let firstsecondBleedWidth = 2 * canvasScale, firstsecondBleedHeight = 2 * canvasScale;
    secondBleedWidth = bleedBase * canvasScale, secondBleedHeight = bleedBase * canvasScale;
    imagePaddingWidth = (bleedBase + 1.5) * canvasScale, imagePaddingHeight = (bleedBase + 1.5) * canvasScale;
    canvasSource.setWidth(diyWorkAreaWidth);
    canvasSource.setHeight(diyWorkAreaHeight);

    if(drawImageUrl != ''){
        if(drawImageUrl.indexOf('diyWeb') == -1){
            if(imgFactWidth > imgFactHeight){
                drawImageUrl = drawImageUrl.split('!')[0] + '!' + '2000x0';
            }else{
                drawImageUrl = drawImageUrl.split('!')[0] + '!' + '0x2000';
            }
        }
        // draw Image
        let fabricImage = new fabric.Image.fromURL(drawImageUrl, function (oImg) {
            oImg.set({
                top:0,
                left:0,
                evented: true,
                selectable: true,
                selectEnabled: true,
                erasable: false,
                cornerSize: 10,
                hasControls: true,

            });
            oImg.setControlsVisibility({
                mtr: false
            });
            if(redrawing){ // Judgment of custom tangent line redrawing
                let dieCutScaleX = (diyWorkAreaWidth - secondBleedWidth * 2) / dieCutWidth;
                let dieCutScaleY = (diyWorkAreaHeight - secondBleedHeight * 2) / dieCutHeight;
                oImg.width = imageWidth * dieCutScaleX;
                oImg.height = imageHeight * dieCutScaleY;
                oImg.left = imgOffsetLeft * dieCutScaleX + secondBleedWidth;
                oImg.top = imgOffsetTop * dieCutScaleY + secondBleedWidth;
                $('.uploadPropTipDiy .Undo').css('display','block');
            }else{
                undoObjArr = [];
                let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
                let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
                let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
                // warnPix
                if(imgToCanScale > 2) {
                    $('.diyTip').css('display','block');
                }
                oImg.scaleX = imgToCanScale;
                oImg.scaleY = imgToCanScale;
                oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
                oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
                $('.uploadPropTipDiy .Undo').css('display','none');
            }
            oImg.objType='image';
            oImg.uniqueId = uniqueId;
            canvasSource.add(oImg);
            canvasSource.setBackgroundColor("white"); // rgba(0,0,0,1)
            canvasSource.renderAll();

            // if(!redrawing){ // NO Judgment of custom tangent line redrawing
            let undoObj = {
                canvasObj: canvasSource.toJSON()
            }
            undoObjArr.push(undoObj);
            // }

            // if(lineType == ''){
            //     if ($('.product__titleh1').text().indexOf("Circle") != -1) {
            //         lineType = 'circle';
            //     } else if($('.product__titleh1').text().indexOf("Oval") != -1 || $('.product__titleh1').text().indexOf("oval") != -1){
            //         lineType = 'circle';
            //     } else {
            //         if($('.product__titleh1').text().indexOf("Round") != -1){
            //             lineType = 'square-circle';
            //         }else{
            //             lineType = 'square-right';
            //         }
            //     }
            // }
            let lineType = $('.choose-lines .active').find('button').attr('line-type');
            if(lineType == 'square-right' || lineType == 'Square' || lineType == 'Rectangle'){
                $('.ShapeselectionDiy button[line-type="square-right"]').parent().addClass('active').siblings().removeClass('active');
                circlesticker = 'rightRect';
                drawBleedRightLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
                if(Number(inchWidth)== Number(inchHeight)){
                    $('.uploadShape').val('Square');
                }else{
                    $('.uploadShape').val('Rectangle');
                }
                // $('.start-draw-diecut-Text').css('display','block');
                $('.start-draw-diecut').css('display','block');
                $('.sure-draw-diecut').css('display','block');
            }else if(lineType == 'square-circle' || lineType == 'Rounded corner square' || lineType == 'Rounded corner rectangle'){
                $('.ShapeselectionDiy button[line-type="square-circle"]').parent().addClass('active').siblings().removeClass('active');
                circlesticker = 'circleRect';
                drawBleedCircleLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
                if(Number(inchWidth)== Number(inchHeight)){
                    $('.uploadShape').val('Rounded corner square');
                }else{
                    $('.uploadShape').val('Rounded corner rectangle');
                }
                // $('.start-draw-diecut-Text').css('display','block');
                $('.start-draw-diecut').css('display','block');
                $('.sure-draw-diecut').css('display','block');
            }else if(lineType == 'circle' || lineType == 'Circle' || lineType == 'Oval'){
                $('.ShapeselectionDiy button[line-type="circle"]').parent().addClass('active').siblings().removeClass('active');
                if(Number(inchWidth)== Number(inchHeight)){
                    circlesticker = 'circle';
                    stickerBorderShade(true, 'circle', secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
                    $('.uploadShape').val('Circle');
                }else{
                    circlesticker = 'ellipse';
                    drawBleedEllipseLine(true, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
                    $('.uploadShape').val('Oval');
                }
                // $('.start-draw-diecut-Text').css('display','block');
                $('.start-draw-diecut').css('display','block');
                $('.sure-draw-diecut').css('display','block');
            }else{

                $('.ShapeselectionDiy button[line-type="diecut"]').parent().addClass('active').siblings().removeClass('active');
                lineType = 'dieCut';
                circlesticker = 'dieCut'
                $('.uploadShape').val('Die cut');
                $('.stickers-cut-line-button-group').addClass('disabled');
            }

            setDemension();
            currentImgObj = canvasSource._objects[0];
            reloadImgObjs.nocropImg = currentImgObj.getSrc();
            reloadImgObjs.noclearImg = currentImgObj.getSrc();
            $('.remove-background').removeClass('on');
            $('.become-clearer').removeClass('on');
            $('.cartreloads').css('display','none');
            startDieCutFlag = false;
            imgFactWidth = oImg.width;
            imgFactHeight = oImg.height;
            if(oImg.width > 2000 || oImg.width > 2000){
                $('.become-clearer').css('display','none');
            }else{
                $('.become-clearer').css('display','flex');
            }
            // setCanvasBgColor(oImg.getSrc());
        },{crossOrigin:"anonymous"});
    }else{
        canvasSource.setBackgroundColor("white"); // rgba(0,0,0,1)
        canvasSource.renderAll();
        if(lineType == ''){
            if ($('.product__titleh1').text().indexOf("Circle") != -1) {
                lineType = 'circle';
            } else if($('.product__titleh1').text().indexOf("Oval") != -1 || $('.product__titleh1').text().indexOf("oval") != -1){
                lineType = 'circle';
            } else {
                if($('.product__titleh1').text().indexOf("Round") != -1){
                    lineType = 'square-circle';
                }else{
                    lineType = 'square-right';
                }
            }
        }
        if(lineType == 'square-right' || lineType == 'Square' || lineType == 'Rectangle'){
            $('.ShapeselectionDiy button[line-type="square-right"]').parent().addClass('active').siblings().removeClass('active');
            circlesticker = 'rightRect';
            drawBleedRightLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
        }else if(lineType == 'square-circle' || lineType == 'Rounded corner square' || lineType == 'Rounded corner rectangle'){
            $('.ShapeselectionDiy button[line-type="square-circle"]').parent().addClass('active').siblings().removeClass('active');
            circlesticker = 'circleRect';
            drawBleedCircleLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
        }else if(lineType == 'circle' || lineType == 'Circle' || lineType == 'Oval'){
            $('.ShapeselectionDiy button[line-type="circle"]').parent().addClass('active').siblings().removeClass('active');
            if(Number(inchWidth)== Number(inchHeight)){
                circlesticker = 'circle';
                stickerBorderShade(true, 'circle', secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
            }else{
                circlesticker = 'ellipse';
                drawBleedEllipseLine(true, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
            }
        }else{
            circlesticker = 'dieCut'
        }
        setDemension();
        $('.remove-background').removeClass('on');
        $('.become-clearer').removeClass('on');
        $('.cartreloads').css('display','none');
        startDieCutFlag = false;
    }

    canvasSource.on('object:modified',function (e) {
        var obj = canvasSource.getActiveObject();
        if(obj.objType == 'draggableDiecut'){
            if($('.choose-lines .active').find('button').attr('line-type') == 'square-right'){
                drawBleedRightLine(false, bleedLineWidth, obj.left, obj.top, canvasSource.getWidth() - obj.left - obj.getScaledWidth(), canvasSource.getHeight() - obj.top - obj.getScaledHeight(), true);
            }else if($('.choose-lines .active').find('button').attr('line-type') == 'square-circle'){
                drawBleedCircleLine(false, bleedLineWidth, obj.left, obj.top, canvasSource.getWidth() - obj.left - obj.getScaledWidth(), canvasSource.getHeight() - obj.top - obj.getScaledHeight(), true);
            }else if($('.choose-lines .active').find('button').attr('line-type') == 'circle'){
                if(obj.getScaledHeight()== obj.getScaledWidth()){
                    circlesticker = 'circle';
                    stickerBorderShade(false, 'circle', obj.left, obj.top, canvasSource.getWidth() - obj.left - obj.getScaledWidth(), canvasSource.getHeight() - obj.top - obj.getScaledHeight(), true);
                }else{
                    circlesticker = 'ellipse';
                    drawBleedEllipseLine(false, obj.left, obj.top, canvasSource.getWidth() - obj.left - obj.getScaledWidth(), canvasSource.getHeight() - obj.top - obj.getScaledHeight(), true);
                }
            }
        }else{
            console.log(canvasSource.toJSON());
            let undoObj = {
                canvasObj: canvasSource.toJSON()
            }
            undoObjArr.unshift(undoObj);
            // undoObjArr.unshift(canvasSource.toJSON());
            $('.uploadPropTipDiy .Undo').css('display','block');
            customerOpearationRecords(recordsParentId, 'Canvas operation', optstep++);
        }
    })

    canvasSource.on('object:scaling',function (e) {
        var obj = canvasSource.getActiveObject();
        if(obj.objType == 'draggableDiecut'){
            if (obj.top < secondBleedWidth) {
                obj.top = secondBleedWidth;
            }
            if (obj.left < secondBleedWidth) {
                obj.left = secondBleedWidth;
            }
            if ((obj.top + obj.getScaledHeight()) > (diyWorkAreaHeight - secondBleedHeight)) {
                obj.set('scaleY', (diyWorkAreaHeight - secondBleedHeight - obj.top) / obj.height )
            }
            if ((obj.left + obj.getScaledWidth()) > (diyWorkAreaWidth - secondBleedWidth)) {
                obj.set('scaleX', (diyWorkAreaWidth - secondBleedWidth - obj.left) / obj.width  )
            }
        }
    })
    /************ Canvas diy end ****************/
}

// Acrylic find the edge results
let acrylicDieCutSvg = '';
// Keychain drilling position
let custMoQie = {};
function initCanvasForAcrylic(iw, ih, data){
    custMoQie = {};
    acrylicDieCutSvg = '';

    $(".page-width .paper-handbag-Diy").remove();
    lineType = 'dieCut';
    drawImageUrl = "https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/" + data.userData.uploadImage;
    imgFactWidth = data.userData.width;
    imgFactHeight = data.userData.height;
    // ... existing code ...
    let autoDesignWidth = imgFactWidth;
    let autoDesignHeight = imgFactHeight;
    let targetInchWidth = iw;  // Final width
    let targetInchHeight = ih; // Final height

    // Calculate the aspect ratio of images and canvases
    const imageRatio = autoDesignWidth / autoDesignHeight;
    const canvasRatio = iw / ih;

    // Adjust dimensions based on aspect ratio
    if (imageRatio > canvasRatio) {
        // The image is wider than the canvas, maintain the width, and proportionally reduce the height
        targetInchHeight = iw / imageRatio;
    } else {
        // The image is higher than the canvas, maintaining the height, and proportionally reduce the width
        targetInchWidth = ih * imageRatio;
    }

    // Ensure that the adjusted size does not exceed the original canvas size
    targetInchWidth = Math.min(targetInchWidth, iw);
    targetInchHeight = Math.min(targetInchHeight, ih);

    // Application final size
    inchWidth = parseFloat(targetInchWidth.toFixed(2));
    inchHeight = parseFloat(targetInchHeight.toFixed(2));
    // ... existing code ...
    btnShowOrHide(false, false)
    inchSourceWidth = inchWidth;
    inchSourceHeight = inchHeight;
    // The distance between the edge search result and the edge of the canvas
    let bleedBase = 3;
    // Image rendering distance from the edge of the canvas
    // V1.0
    // let drawbleedBase = Number(acrylicInchWidth) + 2;
    // mm
    if(UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
        // V1.0
        // drawbleedBase = Number(acrylicInchWidth) * 1.5 + 3; // Reserved card slot position for acrylic stand
        workAreaWidth =  Math.round(inchWidth*25.4+(bleedBase * 2));
        workAreaHeight =  Math.round(inchHeight*25.4+(bleedBase * 2))
    }else{
        workAreaWidth =  Math.round(inchWidth*25.4+(bleedBase * 2));
        workAreaHeight =  Math.round(inchHeight*25.4+(bleedBase * 2));
    }

    $(".sticker-preview-preview").parents(".uploadPropTipDiy").addClass('dialog-' + productType);
    $('.cartreloads').find('p').text('Loading your design...');
    $('.cartreloads').css('display','block');
    /************ Canvas diy start ****************/

    if (window.document.body.clientWidth < 750){
        diyWorkAreaWidth = $(window).width() * 0.95 - 80;
        diyWorkAreaHeight = diyWorkAreaWidth
    }else{
        diyWorkAreaWidth = canvasInitSize;
        diyWorkAreaHeight = canvasInitSize;
    }

    let canvasId = 'cas-res';
    var existingCanvas = document.getElementById(canvasId);
    if (!existingCanvas) {
        $('.uploadPropTipDiy .can-resource').append('<canvas id="cas-res" ></canvas>');
        canvasSource = new fabric.Canvas(canvasId);
    } else {
        canvasSource = new fabric.Canvas(existingCanvas);
        canvasSource.clear();
    }
    canvasSource.preserveObjectStacking = true;

    let canvasScale = 1;
    if(workAreaWidth > workAreaHeight){
        canvasScale = diyWorkAreaWidth / workAreaWidth;
        diyWorkAreaHeight = workAreaHeight * canvasScale;
    }else{
        canvasScale = diyWorkAreaHeight / workAreaHeight;
        diyWorkAreaWidth = workAreaWidth * canvasScale;
    }
    // let firstsecondBleedWidth = 1.5 * canvasScale, firstsecondBleedHeight = 1.5 * canvasScale;
    secondBleedWidth = bleedBase * canvasScale, secondBleedHeight = bleedBase * canvasScale;
    // V1.0
    // imagePaddingWidth = drawbleedBase * canvasScale, imagePaddingHeight = drawbleedBase * canvasScale;
    // V2.0
    imagePaddingWidth = (bleedBase + 2) * canvasScale, imagePaddingHeight = (bleedBase + 2) * canvasScale;
    canvasSource.setWidth(diyWorkAreaWidth);
    canvasSource.setHeight(diyWorkAreaHeight);

    if(drawImageUrl != ''){
        if(drawImageUrl.indexOf('diyWeb') == -1){
            if(imgFactWidth > imgFactHeight){
                drawImageUrl = drawImageUrl.split('!')[0] + '!' + '2000x0';
            }else{
                drawImageUrl = drawImageUrl.split('!')[0] + '!' + '0x2000';
            }
        }
        // draw Image
        let fabricImage = new fabric.Image.fromURL(drawImageUrl, function (oImg) {
            oImg.set({
                top:0,
                left:0,
                evented: false,
                selectable: false,
                erasable: false,
            });
            undoObjArr = [];
            let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
            let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
            let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);

            oImg.scaleX = imgToCanScale;
            oImg.scaleY = imgToCanScale;
            oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
            // V1.0
            // if(UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
            //     oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2 - (canvasScale * Number(acrylicInchWidth) * 0.75);
            // }else{
            //     oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
            // }
            // V2.0
            if(UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
                oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2 - canvasScale * 1.5;
            }else{
                oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2 + canvasScale * 1.5;
            }
            $('.uploadPropTipDiy .Undo').css('display','none');
            oImg.objType='image';
            oImg.uniqueId = uniqueId;
            canvasSource.add(oImg);
            canvasSource.setBackgroundColor("white"); // rgba(0,0,0,1)
            canvasSource.renderAll();

            setDemension();
            currentImgObj = canvasSource._objects[0];

            startDieCutFlag = false;
            imgFactWidth = oImg.width;
            imgFactHeight = oImg.height;
            $('.img-btn-boxbu').css('display','none');
            // setCanvasBgColor(oImg.getSrc());

            canvasSource.setBackgroundColor("rgba(0,0,0,0)");
            if(canvasSource._objects[0].mediaIsBG){
                canvasSource._objects[0].visible = false;
            }
            canvasSource.renderAll();
            var data = {
                imgPath: canvasSource.toDataURL('image/png'),
                lineType: '',
                designwidth: workAreaWidth,
                designheight: workAreaHeight,
            };
            if(UploadProductType.UploadProductType.name == 'labels$keychains'){
                data.lineType = 'cricle';
            }else{
                data.lineType = 'dieCut';
            }
            canvasSource.setBackgroundColor("white");
            if(canvasSource._objects[0].mediaIsBG){
                canvasSource._objects[0].visible = true;
            }
            canvasSource.renderAll();
            if(oImg.width > 2000 || oImg.height> 2000){
                $('.become-clearer').css('display','none');
            }else{
                $('.become-clearer').css('display','flex');
            }
            // 画布截图 开始异形寻边获取SVG模切线
            $.ajax({
                // V1.0
                // url: "https://diy.racetopprint.com/diyWeb/csrdiy/generateCuttingLines.do",
                // V2.0
                url: "https://diy.racetopprint.com/diyWeb/csrdiy/generateCuttingLinesV2.do",
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function(res) {
                    if(res.success){
                        $('.cartreloads').css('display','none');
                        acrylicDieCutSvg = 'https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/' +  res.userData.svgPath;
                        let maskImageUrl = 'https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/' +  res.userData.pngPath;
                        let fabricImageMask = new fabric.Image.fromURL(maskImageUrl, function (maskImg) {
                            maskImg.set({
                                top:0,
                                left:0,
                                evented: false,
                                selectable: false,
                                erasable: false,
                            });

                            let maskImgToCanScaleX = (diyWorkAreaWidth ) / maskImg.width;
                            let maskImgToCanScaleY = (diyWorkAreaHeight ) / maskImg.height;
                            let maskImgToCanScale = Math.min(maskImgToCanScaleX, maskImgToCanScaleY);
                            maskImg.scaleX = maskImgToCanScale;
                            maskImg.scaleY = maskImgToCanScale;
                            canvasSource.add(maskImg);
                            canvasSource.renderAll();
                        },{crossOrigin:"anonymous"})

                        if(UploadProductType.UploadProductType.name == 'labels$keychains'){
                            // Customized punching and die-cutting for keychains
                            if(res.userData.Cricle_info){
                                // V1.0
                                /*var left = res.userData.Cricle_info.cx-res.userData.Cricle_info.r,//钥匙空位置调整（页面显示）
                                   top = res.userData.Cricle_info.cy;*/
                                // V2.0
                                // 半径2mm 计算得到
                                var rpx = diyWorkAreaWidth / workAreaWidth * 2;
                                var left = res.userData.Cricle_info.cx - rpx,
                                    top = res.userData.Cricle_info.cy - rpx;
                                var canvasObject = new fabric.Circle({
                                    left: left,
                                    top: top,
                                    stroke: 'red',
                                    fill: "rgba(255, 255, 255, 0)",
                                    // V1.0
                                    // radius: res.userData.Cricle_info.r,
                                    radius: rpx,
                                    strokeWidth: 1,
                                    strokeDashArray: [4,3],
                                    isCustMoQie: true,
                                    evented: false,
                                    selectable: false,
                                    erasable: false,
                                });
                                // canvasObject.setControlsVisibility({mt: false, mb: false, ml: false, mr: false, tr: false, tl: false, br: false, bl: false, mtr: false});
                                canvasSource.add(canvasObject);
                                canvasSource.renderAll();
                                // V1.0
                                // custMoQie.cx = res.userData.Cricle_info.cx-res.userData.Cricle_info.r;//钥匙空位置调整（生产合成稿）
                                // custMoQie.cy = res.userData.Cricle_info.cy;
                                // custMoQie.r = res.userData.Cricle_info.r;
                                // V2.0
                                custMoQie.cx = res.userData.Cricle_info.cx;//钥匙空位置调整（生产合成稿）
                                custMoQie.cy = res.userData.Cricle_info.cy;
                                custMoQie.r = rpx;
                            }
                        }
                    }else{
                        $('.cartreloads').css('display','none');
                        $('.InstructionsTip1').css('display','block')
                    }
                },
                error: function(error) {
                    $('.cartreloads').css('display','none');
                    $('.InstructionsTip1').css('display','block')
                }
            });

        },{crossOrigin:"anonymous"});
        circlesticker = 'acrylic';
    }

    /************ Canvas diy end ****************/
}

// Adjust Cut Area   moqie-line-undo
let loadBleedLineFromUndo = function(undoObj){
    if(undoObj.lineType == 'square-right'){
        drawBleedRightLine(false, bleedLineWidth, undoObj.shadeLeftWidth, undoObj.shadeTopHeight, undoObj.shadeRightWidth, undoObj.secondBottomHeight, false);
    }else if(undoObj.lineType == 'square-circle'){
        drawBleedCircleLine(false, bleedLineWidth, undoObj.shadeLeftWidth, undoObj.shadeTopHeight, undoObj.shadeRightWidth, undoObj.secondBottomHeight, false);
    }else if(undoObj.lineType == 'circle'){
        circlesticker = 'circle';
        stickerBorderShade(false, 'circle', undoObj.shadeLeftWidth, undoObj.shadeTopHeight, undoObj.shadeRightWidth, undoObj.secondBottomHeight, false);
    }else if(undoObj.lineType == 'ellipse'){
        circlesticker = 'ellipse';
        drawBleedEllipseLine(false, undoObj.shadeLeftWidth, undoObj.shadeTopHeight, undoObj.shadeRightWidth, undoObj.secondBottomHeight, false);
    }
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'draggableDiecut'){
            canvasSource._objects[index].left = undoObj.dragLet;
            canvasSource._objects[index].top = undoObj.dragTop;
            canvasSource._objects[index].scaleX = undoObj.dragScaleX;
            canvasSource._objects[index].scaleY = undoObj.dragScaleY;
        }
    }
    if(undoObjArr.length == 1){
        $('.uploadPropTipDiy .Undo').css('display','none');
    }
    undoObjArr.splice(0,1);
}

let loadFromCustomJSON = function (undoObjArr, isUndo) {
    canvasSource.loadFromJSON(undoObjArr[1].canvasObj, function (o, object) {
        canvasSource.renderAll();
        for (let index = 0; index < canvasSource._objects.length; index++) {
            if(canvasSource._objects[index].objType == 'image'){
                currentImgObj = canvasSource._objects[index];
            }
        }
        if(currentImgObj){
            uniqueId = currentImgObj.uniqueId;
            $('.uploadImgid').val(uniqueId);
        }
        if(currentImgObj && currentImgObj.isCrop){
            $('.remove-background').addClass('on')
        }else{
            $('.remove-background').removeClass('on')
        }
        if(currentImgObj && currentImgObj.isClear){
            $('.become-clearer').addClass('on');
        }else{
            $('.become-clearer').removeClass('on');
        }
        saveRecordsFlag = false;
        if(lineType != 'dieCut'){
            $('.choose-lines .active').find('button').trigger('click');
        }
        // clear cutAreaObj
        for (let i = 0; i < undoObjArr.length; i++) {
            if(undoObjArr[i].cutAreaObj != undefined){
                undoObjArr.splice(i,1);
            }
        }
        if(undoObjArr.length > 1){
            undoObjArr.splice(0,1);
        }
        if(undoObjArr.length <= 2){
            $('.uploadPropTipDiy .Undo').css('display','none');
        }
    })
}

/****************Click*****************/
function undoJson(){
    loadFromCustomJSON(undoObjArr, true);
    customerOpearationRecords(recordsParentId, 'Undo', optstep++);
}

$('.uploadPropTipDiy .Undo').on('click', function(){
    if(undoObjArr[1].cutAreaObj == undefined && startDieCutFlag){
        startDieCutFlag = false;
        $('.stickers-cut-line-button-area').removeClass('stickers-cut-line-active').eq(1).addClass('stickers-cut-line-active');
        for (let index = 0; index < canvasSource._objects.length; index++) {
            if(canvasSource._objects[index].objType == 'draggableDiecut'){
                canvasSource._objects.splice(index,1);
                index--;
            }
        }
        undoJson();
        /*$('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                undoJson();
            }
        }, 100)*/
    } else if (undoObjArr[1].cutAreaObj != undefined && startDieCutFlag){
        loadBleedLineFromUndo(undoObjArr[1].cutAreaObj)
    } else {
        undoJson();
    }

    /*if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                undoJson();
            }
        }, 100)
    }else{
        undoJson();
    }*/
})

let cutShapeTipFlag = true;
$(".uploadPropTipDiyDivLeft .close-shape-m-tooltip").on("click",function() {
    cutShapeTipFlag = false;
    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
})

function changeLines($that){
    let prevLineType = $('.choose-lines .active').find('button').attr('line-type')
    $that.parent().addClass('active').siblings().removeClass('active')
    let chooseLineType = $that.attr('line-type');
    if((chooseLineType == 'square-right' || chooseLineType == 'square-circle' || chooseLineType == 'circle') && circlesticker == 'dieCut'){
        $('.canvas-container').remove();
        $('.remove-background').removeClass('on');
        $('.become-clearer').removeClass('on');
        initCanvas(inchWidth, inchHeight, reloadImgObjs.noclearImg?reloadImgObjs.noclearImg:drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, $that.attr('line-type'), productType);
        if(saveRecordsFlag){
            customerOpearationRecords(recordsParentId, 'Shape selection', optstep++);
        }
        saveRecordsFlag = true;

        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("square") != -1 && chooseLineType == 'square-right'){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else if($('.stickersLabels').text().indexOf("rounded") != -1 && chooseLineType == 'square-circle'){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else if($('.stickersLabels').text().indexOf("circle") != -1 && chooseLineType == 'circle'){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else if($('.stickersLabels').text().indexOf("dieCut") != -1 && chooseLineType == 'diecut'){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else {
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        return
    } else if(!(chooseLineType == 'square-right' || chooseLineType == 'square-circle' || chooseLineType == 'circle') && circlesticker != 'dieCut'){
        $('.remove-background').removeClass('on');
        $('.become-clearer').removeClass('on');
        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("dieCut") != -1){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else{
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        // Acrylic keychain and new die-cutting method for standing signs
        if(UploadProductType.UploadProductType.name == 'labels$keychains' || UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
            // Extracting images to obtain width and height, recalculating canvas size
            // shilishilishili
            // let data = JSON.parse('{"success":true,"message":"success","userData":{"filename":"b830f916898c49b596139e0a353aa923","filelength":"421984","width":"528","uploadImage":"printdiy2/M00/42/9E/pRYDAGf_QViAKleDAAZwYHOqd0Y896.png","height":"806"}}');
            // if (data.userData.uploadImage == '') {
            //     $('.cartreloads').css('display','none');
            //     tipShow('Remove background failed')
            //     return;
            // }
            // initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);

            $.ajax({
                url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
                method: 'post',
                data: {
                    imagePath: drawImageUrl.split('!')[0]
                },
                success: function (data) {
                    if (data.success) {
                        if (data.userData.uploadImage == '') {
                            $('.cartreloads').css('display','none');
                            tipShow('Remove background failed')
                            return;
                        }
                        $('.canvas-container').remove();
                        initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);
                    } else {
                        $('.cartreloads').css('display','none');
                        tipShow('Remove background failed')
                    }
                },
                error: function (data) {
                    $('.cartreloads').css('display','none');
                    tipShow('Remove background failed')
                }
            });
        }else{
            getExtractDieCutData(inchWidth, inchHeight, reloadImgObjs.noclearImg?reloadImgObjs.noclearImg:drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, circlesticker, productType, prevLineType);
        }

        return
    }
    delete canvasSource.overlayImage
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'bleedLine'){
            canvasSource._objects.splice(index,1);
            index--;
        }
    }
    canvasSource.renderAll();
    if($that.attr('line-type') == 'square-right'){
        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("square") != -1){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else{
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        circlesticker = 'rightRect';
        drawBleedRightLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
        if(Number(inchWidth)== Number(inchHeight)){
            $('.uploadShape').val('Square');
        }else{
            $('.uploadShape').val('Rectangle');
        }
    }else if($that.attr('line-type') == 'square-circle'){
        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("rounded") != -1){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else{
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        circlesticker = 'circleRect';
        drawBleedCircleLine(true, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
        if(Number(inchWidth)== Number(inchHeight)){
            $('.uploadShape').val('Rounded corner square');
        }else{
            $('.uploadShape').val('Rounded corner rectangle');
        }
    }else if($that.attr('line-type') == 'circle'){
        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("circle") != -1){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else{
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        if(Number(inchWidth)== Number(inchHeight)){
            circlesticker = 'circle';
            stickerBorderShade(true, 'circle', secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
            $('.uploadShape').val('Circle');
        }else{
            circlesticker = 'ellipse';
            drawBleedEllipseLine(true, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
            $('.uploadShape').val('Oval');
        }
    }else{
        if(cutShapeTipFlag){
            if($('.stickersLabels').text().indexOf("dieCut") != -1){
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
            }else{
                $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
            }
        }
        circlesticker = 'dieCut'
        $('.uploadShape').val('Die cut');
    }

    if(saveRecordsFlag){
        customerOpearationRecords(recordsParentId, 'Shape selection', optstep++);
    }
    saveRecordsFlag = true;

}
$('.uploadPropTipDiy .choose-lines').on('click', 'button', function(){
    if(UploadProductType.UploadProductType.name=="sticker$coasters"){//杯垫移出形状切换提示
        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").remove();
    }
    if(!canvasSource){
        $(this).parent().addClass('active').siblings().removeClass('active');
        let prevLineType = $('.choose-lines .active').find('button').attr('line-type')
        if(prevLineType == 'square-right'){
            if(cutShapeTipFlag){
                if($('.stickersLabels').text().indexOf("square") != -1){
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                }else{
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
                }
            }
        }else if(prevLineType == 'square-circle'){
            if(cutShapeTipFlag){
                if($('.stickersLabels').text().indexOf("rounded") != -1){
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                }else{
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
                }
            }
        }else if(prevLineType == 'circle'){
            if(cutShapeTipFlag){
                if($('.stickersLabels').text().indexOf("circle") != -1){
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                }else{
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
                }
            }
        }else{
            if(cutShapeTipFlag){
                if($('.stickersLabels').text().indexOf("dieCut") != -1){
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                }else{
                    $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
                }
            }
        }
        $('.uploadShape').val(prevLineType);
        return;
    }
    var buttonText = this.innerText;
    if (buttonText == 'Die cut') {
        $('.stickers-cut-line-button-group').addClass('disabled');
    } else {
        $('.stickers-cut-line-button-group').removeClass('disabled');
    }
    let $that = $(this);
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                changeLines($that);
            }
        }, 100)
    }else{
        changeLines($that);
    }
})

/************ Image start ****************/
function removeBackground($that){
    if(currentImgObj == ''){
        return
    }
    let isClear = false;
    if(currentImgObj.isClear) {
        isClear = currentImgObj.isClear;
    }
    // reload
    if($that.hasClass('on')){
        customerOpearationRecords(recordsParentId, 'Revert Remove background', optstep++);
        $('.cartreloads').find('p').text('resetting...');
        $('.cartreloads').css('display','block');
        $that.removeClass('on');
        new fabric.Image.fromURL(reloadImgObjs.nocropImg, function (oImg) {
            canvasSource.remove(currentImgObj);
            oImg.set({
                top:0,
                left:0,
                evented: true,
                selectable: true,
                selectEnabled: true,
                erasable: false,
            });
            oImg.setControlsVisibility({
                mtr: false
            });
            let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
            let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
            let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
            // warnPix
            if(imgToCanScale > 2) {
                $('.diyTip').css('display','block');
            }
            canvasSource.setWidth(diyWorkAreaWidth);
            canvasSource.setHeight(diyWorkAreaHeight);
            oImg.scaleX = imgToCanScale;
            oImg.scaleY = imgToCanScale;
            oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
            oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
            oImg.objType='image';
            oImg.uniqueId = uniqueId;
            if(isClear){
                oImg.isClear = isClear;
            }
            canvasSource.add(oImg);
            canvasSource.sendToBack(oImg);
            canvasSource.renderAll();
            currentImgObj = canvasSource._objects[0];
            drawImageUrl = currentImgObj.getSrc();
            let undoObj = {
                canvasObj: canvasSource.toJSON()
            }
            undoObjArr.unshift(undoObj);
            // undoObjArr.unshift(canvasSource.toJSON());
            $('.cartreloads').css('display','none');
            $('.uploadPropTipDiy .Undo').css('display','block');
            imgFactWidth = oImg.width;
            imgFactHeight = oImg.height;
        },{crossOrigin:"anonymous"});
    }else{
        customerOpearationRecords(recordsParentId, 'Remove background', optstep++);
        $('.cartreloads').find('p').text('Remove background...');
        $('.cartreloads').css('display','block');
        $that.addClass('on');
        let canvasImg = currentImgObj.getSrc();
        $.ajax({
            url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
            method: 'post',
            data: {
                imagePath: canvasImg
            },
            success: function (data) {
                if (data.success) {
                    if (data.userData.uploadImage == '') {
                        $('.cartreloads').css('display','none');
                        tipShow('Remove background failed')
                        return;
                    }
                    new fabric.Image.fromURL("https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/" + data.userData.uploadImage, function (oImg) {
                        canvasSource.remove(currentImgObj);
                        oImg.set({
                            top:0,
                            left:0,
                            evented: true,
                            selectable: true,
                            selectEnabled: true,
                            erasable: false,
                        });
                        oImg.setControlsVisibility({
                            mtr: false
                        });
                        let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
                        let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
                        let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
                        // warnPix
                        if(imgToCanScale > 2) {
                            $('.diyTip').css('display','block');
                        }
                        canvasSource.setWidth(diyWorkAreaWidth);
                        canvasSource.setHeight(diyWorkAreaHeight);
                        oImg.scaleX = imgToCanScale;
                        oImg.scaleY = imgToCanScale;
                        oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
                        oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
                        oImg.objType='image';
                        oImg.uniqueId = uniqueId;
                        oImg.isCrop = true;
                        if(isClear) {
                            oImg.isClear = isClear;
                        }
                        canvasSource.add(oImg);
                        canvasSource.sendToBack(oImg);
                        canvasSource.renderAll();
                        currentImgObj = canvasSource._objects[0];
                        drawImageUrl = currentImgObj.getSrc();
                        let undoObj = {
                            canvasObj: canvasSource.toJSON()
                        }
                        undoObjArr.unshift(undoObj);
                        // undoObjArr.unshift(canvasSource.toJSON());
                        $('.cartreloads').css('display','none');
                        $('.uploadPropTipDiy .Undo').css('display','block');
                        imgFactWidth = oImg.width;
                        imgFactHeight = oImg.height;
                    },{crossOrigin:"anonymous"});
                } else {
                    $('.cartreloads').css('display','none');
                    tipShow('Remove background failed')
                }
            },
            error: function (data) {
                $('.cartreloads').css('display','none');
                tipShow('Remove background failed')
            }
        });
    }
}

$('.uploadPropTipDiy .remove-background').click(function(){
    let $that = $(this);
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                removeBackground($that);
            }
        }, 200)
    }else{
        removeBackground($that);
    }
})

function becomeClearer($that){
    if(lineType !== 'dieCut' && currentImgObj == ''){
        return
    }
    let isCrop = false;
    if(currentImgObj.isCrop) {
        isCrop = currentImgObj.isCrop;
    }
    // reload
    if($that.hasClass('on')){
        customerOpearationRecords(recordsParentId, 'Revert Become clearer', optstep++);
        $('.cartreloads').find('p').text('resetting...');
        $('.cartreloads').css('display','block');
        $that.removeClass('on');
        if(lineType == 'dieCut'){
            getExtractDieCutData(inchWidth, inchHeight, reloadImgObjs.noclearImg, imgFactWidth, imgFactHeight, uniqueId, lineType, productType);
            return;
        }
        new fabric.Image.fromURL(reloadImgObjs.noclearImg, function (oImg) {
            canvasSource.remove(currentImgObj);
            oImg.set({
                top:0,
                left:0,
                evented: true,
                selectable: true,
                selectEnabled: true,
                erasable: false,
            });
            oImg.setControlsVisibility({
                mtr: false
            });
            let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
            let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
            let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
            // warnPix
            if(imgToCanScale > 2) {
                $('.diyTip').css('display','block');
            }
            canvasSource.setWidth(diyWorkAreaWidth);
            canvasSource.setHeight(diyWorkAreaHeight);
            oImg.scaleX = imgToCanScale;
            oImg.scaleY = imgToCanScale;
            oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
            oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
            oImg.objType='image';
            oImg.uniqueId = uniqueId;
            if(isCrop){
                oImg.isCrop = isCrop;
            }
            canvasSource.add(oImg);
            canvasSource.sendToBack(oImg);
            canvasSource.renderAll();
            currentImgObj = canvasSource._objects[0];
            drawImageUrl = currentImgObj.getSrc();
            let undoObj = {
                canvasObj: canvasSource.toJSON()
            }
            undoObjArr.unshift(undoObj);
            // undoObjArr.unshift(canvasSource.toJSON());
            $('.cartreloads').css('display','none');
            $('.uploadPropTipDiy .Undo').css('display','block');
            imgFactWidth = oImg.width;
            imgFactHeight = oImg.height;
        },{crossOrigin:"anonymous"});
    }else{
        customerOpearationRecords(recordsParentId, 'Become clearer', optstep++);
        $('.cartreloads').find('p').text('Become clearer...');
        $('.cartreloads').css('display','block');
        $that.addClass('on');
        let canvasImg;
        if(lineType !== 'dieCut'){
            canvasImg = currentImgObj.getSrc();
        } else {
            canvasImg = drawImageUrl;
        }
        if(canvasImg.indexOf('!')!= -1){
            canvasImg = canvasImg.split('!')[0];
        }else{
            canvasImg = canvasImg.replace('large', 'normal');
        }
        $.ajax({
            url: "https://diy.racetopprint.com/diyWeb/csrdiy/maskSuperResolutionImage_sjky.do",
            method: 'get',
            data: {
                imagePath: canvasImg
            },
            success: function (data) {
                if (data.success) {
                    if (data.userData.imagePath == '') {
                        $('.cartreloads').css('display','none');
                        tipShow('Not satisfied with the clarity? Get a proof version within 24 hours of ordering!')
                        return;
                    }
                    let superImgPath = data.userData.imagePath;
                    if(superImgPath.indexOf('https://') == -1){
                        superImgPath = "https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/" + data.userData.imagePath
                    }
                    if(lineType == 'dieCut'){
                        // Acrylic keychain and new die-cutting method for standing signs
                        if(UploadProductType.UploadProductType.name == 'labels$keychains' || UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
                            // Extracting images to obtain width and height, recalculating canvas size
                            // shilishilishili
                            // let data = JSON.parse('{"success":true,"message":"success","userData":{"filename":"b830f916898c49b596139e0a353aa923","filelength":"421984","width":"528","uploadImage":"printdiy2/M00/42/9E/pRYDAGf_QViAKleDAAZwYHOqd0Y896.png","height":"806"}}');
                            // if (data.userData.uploadImage == '') {
                            //     $('.cartreloads').css('display','none');
                            //     tipShow('Remove background failed')
                            //     return;
                            // }
                            // initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);

                            $.ajax({
                                url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
                                method: 'post',
                                data: {
                                    imagePath: drawImageUrl.split('!')[0]
                                },
                                success: function (data) {
                                    if (data.success) {
                                        if (data.userData.uploadImage == '') {
                                            $('.cartreloads').css('display','none');
                                            tipShow('Remove background failed')
                                            return;
                                        }
                                        $('.canvas-container').remove();
                                        initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);
                                    } else {
                                        $('.cartreloads').css('display','none');
                                        tipShow('Remove background failed')
                                    }
                                },
                                error: function (data) {
                                    $('.cartreloads').css('display','none');
                                    tipShow('Remove background failed')
                                }
                            });
                        }else{
                            dieCutResultData.clearData = null
                            getExtractDieCutData(inchWidth, inchHeight, superImgPath, data.userData.width, data.userData.height, uniqueId, lineType, productType, '', reloadImgObjs.noclearImg, true);
                        }
                        return;
                    }
                    new fabric.Image.fromURL(superImgPath.replace('/normal/', '/large/'), function (oImg) {
                        canvasSource.remove(currentImgObj);
                        oImg.set({
                            top:0,
                            left:0,
                            evented: true,
                            selectable: true,
                            selectEnabled: true,
                            erasable: false,
                        });
                        oImg.setControlsVisibility({
                            mtr: false
                        });
                        let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
                        let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
                        let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
                        // warnPix
                        if(imgToCanScale > 2) {
                            $('.diyTip').css('display','block');
                        }
                        canvasSource.setWidth(diyWorkAreaWidth);
                        canvasSource.setHeight(diyWorkAreaHeight);
                        oImg.scaleX = imgToCanScale;
                        oImg.scaleY = imgToCanScale;
                        oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
                        oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
                        oImg.objType='image';
                        oImg.uniqueId = uniqueId;
                        if(isCrop) {
                            oImg.isCrop = isCrop;
                        }
                        canvasSource.add(oImg);
                        canvasSource.sendToBack(oImg);
                        canvasSource.renderAll();
                        currentImgObj = canvasSource._objects[0];
                        drawImageUrl = currentImgObj.getSrc();
                        let undoObj = {
                            canvasObj: canvasSource.toJSON()
                        }
                        undoObjArr.unshift(undoObj);
                        // undoObjArr.unshift(canvasSource.toJSON());
                        $('.cartreloads').css('display','none');
                        $('.uploadPropTipDiy .Undo').css('display','block');
                        imgFactWidth = oImg.width;
                        imgFactHeight = oImg.height;
                    },{crossOrigin:"anonymous"});
                } else {
                    $('.cartreloads').css('display','none');
                    tipShow('Not satisfied with the clarity? Get a proof version within 24 hours of ordering!')
                }
            },
            error: function (data) {
                $('.cartreloads').css('display','none');
                tipShow('Not satisfied with the clarity? Get a proof version within 24 hours of ordering!')
            }
        });
    }
}

$('.uploadPropTipDiy .become-clearer').click(function(){
    let $that = $(this);
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                becomeClearer($that);
            }
        }, 200)
    }else{
        becomeClearer($that);
    }
})

function changeImageSize(type){
    if(currentImgObj == ''){
        return
    }
    let oldImgWidth = currentImgObj.getScaledWidth();
    let oldImgHeight = currentImgObj.getScaledHeight();
    // currentImgObj.left = (diyWorkAreaWidth - currentImgObj.getScaledWidth()) / 2;
    // currentImgObj.top = (diyWorkAreaHeight - currentImgObj.getScaledHeight()) / 2;
    if(type == 'enlarge'){
        let add=1.05;
        currentImgObj.set('scaleX', currentImgObj.scaleX*add);
        currentImgObj.set('scaleY', currentImgObj.scaleY*add);
        currentImgObj.left = currentImgObj.left - Math.abs((oldImgWidth - currentImgObj.getScaledWidth()) / 2);
        currentImgObj.top = currentImgObj.top -  Math.abs((oldImgHeight - currentImgObj.getScaledHeight()) / 2);
        customerOpearationRecords(recordsParentId, 'Image enlargement', optstep++);
    }else{
        let add=0.95;
        currentImgObj.set('scaleX', currentImgObj.scaleX*add);
        currentImgObj.set('scaleY', currentImgObj.scaleY*add);
        currentImgObj.left = currentImgObj.left + Math.abs((oldImgWidth - currentImgObj.getScaledWidth()) / 2);
        currentImgObj.top = currentImgObj.top +  Math.abs((oldImgHeight - currentImgObj.getScaledHeight()) / 2);
        customerOpearationRecords(recordsParentId, 'Image shrink', optstep++);
    }
    canvasSource.discardActiveObject();
    canvasSource.renderAll();
    let undoObj = {
        canvasObj: canvasSource.toJSON()
    }
    undoObjArr.unshift(undoObj);
    // undoObjArr.unshift(canvasSource.toJSON());
    $('.uploadPropTipDiy .Undo').css('display','block');
}

$('.uploadPropTipDiy .img-btn-boxbu .enlarge').click(function(){
    if(!canvasSource) return;
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                changeImageSize('enlarge');
            }
        }, 100)
    }else{
        changeImageSize('enlarge');
    }
})

$('.uploadPropTipDiy .img-btn-boxbu .narrow').click(function(){
    if(!canvasSource) return;
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                changeImageSize('narrow');
            }
        }, 100)
    }else{
        changeImageSize('narrow');
    }
})

function changeImage(){
    $('.cartreloads').find('p').text('Uploading...');
    $('.cartreloads').css('display','block');
    var formData = new FormData();
    if (!$('.uploadPropInputDiy')[0].files.length) {
        $('.cartreloads').css('display','none');
        tipShow('Please select a file')
        return
    }
    $('#ContinueFunzId1').css('pointer-events', 'none')
    $('#ContinueFunzId1').css('background', '#ddd')
    var str=$('.uploadPropInputDiy')[0].files[0].name.split('.')[$('.uploadPropInputDiy')[0].files[0].name.split('.').length-1]
    // if(str.indexOf('jpeg')>=0||str.indexOf('jpg')>=0||str.indexOf('png')>=0||str.indexOf('JPEG')>=0||str.indexOf('JPG')>=0||str.indexOf('PNG')>=0){
    formData.append('file', $('.uploadPropInputDiy')[0].files[0]);

    formData.append('goodsname', $('.product__titleh1').text());

    if ($('.uploadProp3Textarea').val()) {
        formData.append('remark', $('.uploadProp3Textareadiy').val());
    }
    customerOpearationRecords(recordsParentId, 'Choose Image', optstep++);
    $.ajax({
        url: "https://diy.racetopprint.com/zlgao/outsideUploadFile/fileUploadnew.do",
        type: 'post',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: res => {
            $('.uploadPropInputDiy').val(null)
            if (res.result == 'true') {
                if(document.querySelector('.pdf-more-tooltip-content') != null){
                    document.querySelector('.pdf-more-tooltip-content').style.display = 'none';
                    document.querySelector('.pdf-more-tooltip').style.display = 'none';
                }
                dieCutResultData = {
                    data: null,
                    clearData: null
                }
                isInstructionsTip=false
                $('#ContinueFunzId1').css('pointer-events', 'initial')
                $('#ContinueFunzId1').css('background', backgroundColor);

                if(cutShapeTipFlag){
                    let prevLineType = $('.choose-lines .active').find('button').attr('line-type')
                    if($('.stickersLabels').text().indexOf("square") != -1 && prevLineType == 'square-right'){
                        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                    }else if($('.stickersLabels').text().indexOf("rounded") != -1 && prevLineType == 'square-circle'){
                        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                    }else if($('.stickersLabels').text().indexOf("circle") != -1 && prevLineType == 'circle'){
                        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                    }else if($('.stickersLabels').text().indexOf("dieCut") != -1 && prevLineType == 'diecut'){
                        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','none');
                    }else {
                        $(".uploadPropTipDiyDivLeft .cut-shape-m-tooltip-content").css('display','flex');
                    }
                }


                // 在产品详情页通过upload按钮直接打开stickers的upload弹窗，此时未执行initCanvas,因此需要执行
                if (!canvasSource) {
                    uniqueId = res.id;
                    $('.uploadImgid').val(uniqueId);
                    if(str.indexOf('jpeg')>=0||str.indexOf('jpg')>=0||str.indexOf('png')>=0||str.indexOf('heic')>=0||str.indexOf('webp')>=0||str.indexOf('pdf')>=0||str.indexOf('JPEG')>=0||str.indexOf('JPG')>=0||str.indexOf('PNG')>=0||str.indexOf('HEIC')>=0||str.indexOf('WEBP')>=0||str.indexOf('PDF')>=0){
                        $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','block');
                        $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','none');

                        let inchWidth = newsize().width
                        let inchHeight = newsize().height;
                        let drawImageUrl = res.path
                        let imgFactWidth = res.widthpx;
                        let imgFactHeight = res.hightpx;
                        // square-right  square-circle  circle
                        var text=''
                        if($('.Shape>div>div').length){
                            text=$('.uploadShape').val()
                        }
                        $('.canvas-container-init').css('display', 'none');
                        // upload more page pdf tip
                        if((str.indexOf('pdf')>=0 || str.indexOf('PDF')>=0) && res.isflow && res.isflow == '1'){
                            console.log('upload more page pdf');
                            if(document.querySelector('.pdf-more-tooltip-content') != null){
                                document.querySelector('.pdf-more-tooltip').style.display = 'block';
                                document.querySelector('.pdf-more-tooltip-content').style.display = 'flex';
                            }
                        }
                        if($('.choose-lines .active').find('button').attr('line-type') == 'diecut') {
                            // Acrylic keychain and new die-cutting method for standing signs
                            if(UploadProductType.UploadProductType.name == 'labels$keychains' || UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
                                acrylicInchWidth = inchWidth;
                                acrylicInchHeight = inchHeight;
                                // Extracting images to obtain width and height, recalculating canvas size
                                // shilishilishili
                                // let data = JSON.parse('{"success":true,"message":"success","userData":{"filename":"b830f916898c49b596139e0a353aa923","filelength":"421984","width":"528","uploadImage":"printdiy2/M00/42/9E/pRYDAGf_QViAKleDAAZwYHOqd0Y896.png","height":"806"}}');
                                // if (data.userData.uploadImage == '') {
                                //     $('.cartreloads').css('display','none');
                                //     tipShow('Remove background failed')
                                //     return;
                                // }
                                // initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);

                                $.ajax({
                                    url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
                                    method: 'post',
                                    data: {
                                        imagePath: drawImageUrl.split('!')[0]
                                    },
                                    success: function (data) {
                                        if (data.success) {
                                            if (data.userData.uploadImage == '') {
                                                $('.cartreloads').css('display','none');
                                                tipShow('Remove background failed')
                                                return;
                                            }
                                            $('.canvas-container').remove();
                                            initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);
                                        } else {
                                            $('.cartreloads').css('display','none');
                                            tipShow('Remove background failed')
                                        }
                                    },
                                    error: function (data) {
                                        $('.cartreloads').css('display','none');
                                        tipShow('Remove background failed')
                                    }
                                });
                            }else{
                                getExtractDieCutData(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, 'dieCut', UploadProductType.UploadProductType.name);
                            }
                        } else {
                            initCanvas(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, text, UploadProductType.UploadProductType.name);
                        }
                    }else{
                        $('.cartreloads').css('display','none');
                        // 提示框
                        $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','none');
                        $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','block');
                    }
                    isaddcart = true;
                    $('#ContinueFunzId1').prop('disabled', false);
                    $('.stickers-cut-line-button-group').removeClass('disabled');
                    uploadSuccess();
                    return;
                }
                if(isProductType==1){

                }else{
                    uniqueId = res.id;
                    $('.uploadImgid').val(uniqueId);
                    if(str.indexOf('jpeg')>=0||str.indexOf('jpg')>=0||str.indexOf('png')>=0||str.indexOf('heic')>=0||str.indexOf('webp')>=0||str.indexOf('pdf')>=0||str.indexOf('JPEG')>=0||str.indexOf('JPG')>=0||str.indexOf('PNG')>=0||str.indexOf('HEIC')>=0||str.indexOf('WEBP')>=0||str.indexOf('PDF')>=0){
                        // if(res.path.split('.')[res.path.split('.').length-1].indexOf('jpeg')>=0||res.path.split('.')[res.path.split('.').length-1].indexOf('png')||res.path.split('.')[res.path.split('.').length-1].indexOf('jpg')){
                        $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','block');
                        $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','none');

                        drawImageUrl = res.path;
                        if(res.widthpx > res.hightpx){
                            drawImageUrl = drawImageUrl.split('!')[0] + '!' + '2000x0';
                        }else{
                            drawImageUrl = drawImageUrl.split('!')[0] + '!' + '0x2000';
                        }
                        // upload more page pdf tip
                        if((str.indexOf('pdf')>=0 || str.indexOf('PDF')>=0) && res.isflow && res.isflow == '1'){
                            console.log('upload more page pdf');
                            document.querySelector('.pdf-more-tooltip').style.display = 'block';
                            document.querySelector('.pdf-more-tooltip-content').style.display = 'flex';
                        }
                        if(lineType == 'dieCut'){
                            $('.uploadImgInput').val(res.path)
                            $('.uploadImgid').val(res.id)
                            $('.remove-background').removeClass('on');
                            $('.become-clearer').removeClass('on');

                            // Acrylic keychain and new die-cutting method for standing signs
                            if(UploadProductType.UploadProductType.name == 'labels$keychains' || UploadProductType.UploadProductType.name == 'labels$acrylicStand'){
                                // Extracting images to obtain width and height, recalculating canvas size
                                // shilishilishili
                                // let data = JSON.parse('{"success":true,"message":"success","userData":{"filename":"b830f916898c49b596139e0a353aa923","filelength":"421984","width":"528","uploadImage":"printdiy2/M00/42/9E/pRYDAGf_QViAKleDAAZwYHOqd0Y896.png","height":"806"}}');
                                // if (data.userData.uploadImage == '') {
                                //     $('.cartreloads').css('display','none');
                                //     tipShow('Remove background failed')
                                //     return;
                                // }
                                // initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);

                                $.ajax({
                                    url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
                                    method: 'post',
                                    data: {
                                        imagePath: drawImageUrl.split('!')[0]
                                    },
                                    success: function (data) {
                                        if (data.success) {
                                            if (data.userData.uploadImage == '') {
                                                $('.cartreloads').css('display','none');
                                                tipShow('Remove background failed')
                                                return;
                                            }
                                            $('.canvas-container').remove();
                                            initCanvasForAcrylic(acrylicInchWidth, acrylicInchHeight, data);
                                        } else {
                                            $('.cartreloads').css('display','none');
                                            tipShow('Remove background failed')
                                        }
                                    },
                                    error: function (data) {
                                        $('.cartreloads').css('display','none');
                                        tipShow('Remove background failed')
                                    }
                                });
                            }else{
                                reloadImgObjs.nocropImg = drawImageUrl;
                                reloadImgObjs.noclearImg = drawImageUrl;
                                getExtractDieCutData(inchWidth, inchHeight, drawImageUrl, res.widthpx, res.hightpx, uniqueId, lineType, productType);
                                uploadSuccess();
                            }
                            return;
                        }
                        new fabric.Image.fromURL(drawImageUrl, function (oImg) {
                            if(oImg.getScaledWidth() == 0 || oImg.getScaledHeight() == 0) {
                                $('.cartreloads').css('display','none');
                                tipShow('upload fail...')
                                return;
                            }
                            if(currentImgObj != ''){
                                canvasSource.remove(currentImgObj);
                            }
                            oImg.set({
                                top:0,
                                left:0,
                                evented: true,
                                selectable: true,
                                selectEnabled: true,
                                erasable: false,
                            });
                            oImg.setControlsVisibility({
                                mtr: false
                            });
                            let imgToCanScaleX = (diyWorkAreaWidth - imagePaddingWidth * 2) / oImg.width;
                            let imgToCanScaleY = (diyWorkAreaHeight  - imagePaddingWidth * 2) / oImg.height;
                            let imgToCanScale = Math.min(imgToCanScaleX, imgToCanScaleY);
                            // warnPix
                            if(imgToCanScale > 2) {
                                $('.diyTip').css('display','block');
                            }
                            canvasSource.setWidth(diyWorkAreaWidth);
                            canvasSource.setHeight(diyWorkAreaHeight);
                            oImg.scaleX = imgToCanScale;
                            oImg.scaleY = imgToCanScale;
                            oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2;
                            oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
                            oImg.objType='image';
                            oImg.uniqueId = uniqueId;
                            canvasSource.add(oImg);
                            canvasSource.sendToBack(oImg);
                            canvasSource.renderAll();
                            let undoObj = {
                                canvasObj: canvasSource.toJSON()
                            }
                            undoObjArr.unshift(undoObj);
                            // undoObjArr.unshift(canvasSource.toJSON());

                            currentImgObj = canvasSource._objects[0];
                            reloadImgObjs.nocropImg = currentImgObj.getSrc();
                            reloadImgObjs.noclearImg = currentImgObj.getSrc();
                            $('.remove-background').removeClass('on');
                            $('.become-clearer').removeClass('on');
                            $('.cartreloads').css('display','none');
                            saveRecordsFlag = false;
                            if(lineType != 'dieCut'){
                                $('.choose-lines .active').find('button').trigger('click');
                            }
                            imgFactWidth = oImg.width;
                            imgFactHeight =  oImg.height;
                            if(imgFactWidth > 2000 || imgFactHeight> 2000){
                                $('.become-clearer').css('display','none');
                            }else{
                                $('.become-clearer').css('display','flex');
                            }
                            // setCanvasBgColor(oImg.getSrc());
                        },{crossOrigin:"anonymous"});
                    }else{
                        // 提示框
                        $('.cartreloads').css('display','none');
                        $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','none');
                        $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','block');
                    }
                }
                $('.uploadImgInput').val(res.path)
                $('.uploadImgid').val(res.id)
                uploadSuccess()
            }else{
                $('.cartreloads').css('display','none');
                tipShow(res.message)
            }
        },error:function(e){
            $('.cartreloads').css('display','none');
            tipShow('upload fail...')
        }
    })
    // }
}
// changge-upload
$('.uploadPropTipDiy .uploadPropInputDiy').change(function() {
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                changeImage();
            }
        }, 200)
    }else{
        changeImage();
    }
})

$('.InstructionsTip button:first-child').click(function(){
    customerOpearationRecords(recordsParentId, 'Close design', optstep++);
    $('.canvas-container').remove();
    inchWidth = '';
    inchHeight = '';
    inchSourceWidth = '';
    inchSourceHeight = '';
    drawImageUrl = '';
    imgFactWidth = '';
    imgFactHeight = '';
    uniqueId = '';
    lineType = '';
    circlesticker = 'rightRect';
    // mm
    workAreaWidth =  '';
    workAreaHeight =  '';
    secondBleedWidth = '';
    imagePaddingWidth = '';
    reloadImgObjs = {
        nocropImg:'',
        noclearImg:''
    }
    dieCutResultData = {
        data: null,
        clearData: null
    }
    $('.uploadPropTipDiy').css('display','none')
    $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','block');
    $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','none');
    $('.uploadProp3Textareadiy').val('')
    $('.uploadPropInputDiy').val('')
    $('.new-start-draw-diecut').removeClass('new-start-draw-diecut-active')
    cutShapeTipFlag = true;
    $('.cut-shape-m-tooltip-content').css('display', 'none');
    startDieCutFlag = false;
    canvasSource=null;
    $('.canvas-container-init').css('display','flex')
    $('.stickers-cut-line-button-group').addClass('disabled');
    $('.stickers-cut-line-button-area').removeClass('stickers-cut-line-active').eq(1).addClass('stickers-cut-line-active');
})

$('.uploadPropTipDiy .diyTip').on('click', 'button', function(){
    if($(this).index() == 0){
        $('.diyTip').css('display','none');
    }else{
        $('.diyTip').css('display','none');
        $('.become-clearer').trigger('click');
    }
})

/************ Image end ****************/


/*********** Fit Image start**************/
function fitImg(){
    if(currentImgObj == ''){
        return
    }
    customerOpearationRecords(recordsParentId, 'Fit Image', optstep++);
    if(inchSourceWidth == '' && inchSourceHeight == ''){
        inchSourceWidth = inchWidth;
        inchSourceHeight= inchHeight;
    }
    let imgCanvasWidth = currentImgObj.getScaledWidth() / currentImgObj.getScaleX();
    let imgCanvasHeight = currentImgObj.getScaledHeight() / currentImgObj.getScaleY();
    let longInch =  Math.max(inchSourceWidth, inchSourceHeight);
    let shortInch =  Math.min(inchSourceWidth, inchSourceHeight);
    if(imgCanvasWidth > imgCanvasHeight){
        inchWidth = longInch;
        inchHeight = Math.round((imgCanvasHeight / imgCanvasWidth * inchWidth) * 10) / 10;
        if(inchHeight > shortInch){
            inchWidth = Math.round((shortInch / inchHeight * inchWidth) * 10) / 10;;
            inchHeight = shortInch;
        }
    }else{
        inchHeight = longInch;
        inchWidth = Math.round((imgCanvasWidth / imgCanvasHeight * inchHeight) * 10) / 10;
        if(inchWidth > shortInch){
            inchHeight =  Math.round((shortInch / inchWidth * inchHeight) * 10) / 10;
            inchWidth = shortInch;
        }
    }
    drawImageUrl = currentImgObj.getSrc()
    reloadImgObjs = {
        nocropImg:'',
        noclearImg:''
    }
    dieCutResultData = {
        data: null,
        clearData: null
    }
    $('.canvas-container').remove();
    if(lineType != 'dieCut'){
        lineType = $('.choose-lines .active').find('button').attr('line-type');
    }
    initCanvas(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType)
}

$('.uploadPropTipDiy .img-btn-boxbuButton').on('click', function(){
    if(!canvasSource) return;
    if(startDieCutFlag){
        $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
        var t1=window.setInterval(function(){
            if(!startDieCutFlag){
                window.clearInterval(t1);
                fitImg();
            }
        }, 200)
    }else{
        fitImg();
    }
})

/*********** Fit Image end **************/

// start custom die
function startDieCut(){
    if(startDieCutFlag) {
        return
    }
    startDieCutFlag = true;
    customerOpearationRecords(recordsParentId, 'start draw dieCut', optstep++);
    delete canvasSource.overlayImage;
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'draggableDiecut' || canvasSource._objects[index].objType == 'bleedLine'){
            canvasSource._objects.splice(index,1);
            index--;
        }
        if(canvasSource._objects[index].objType == 'image'){
            canvasSource._objects[index].evented = false;
            canvasSource._objects[index].selectable = false;
        }
    }
    canvasSource.discardActiveObject();
    if($('.choose-lines .active').find('button').attr('line-type') == 'square-right'){
        let rect = new fabric.Rect({
            left: secondBleedWidth,
            top: secondBleedHeight,
            fill: 'transparent',
            stroke: 'red',
            width: canvasSource.getWidth() - (secondBleedWidth * 2 + bleedLineWidth) ,
            height: canvasSource.getHeight() - (secondBleedHeight * 2 + bleedLineWidth),
            strokeWidth: 2,
            objType:'draggableDiecut',
            lockMovementX:true,
            lockMovementY:true,
            lockScalingFlip:true,
        });
        rect.setControlVisible('mtr', false);
        canvasSource.add(rect);
        canvasSource.setActiveObject(rect);
        canvasSource.renderAll();
        drawBleedRightLine(false, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
    }else if($('.choose-lines .active').find('button').attr('line-type') == 'square-circle'){
        let filletRadius = 5 * 3.79;
        let rect = new fabric.Rect({
            left: secondBleedWidth,
            top: secondBleedHeight,
            width: canvasSource.getWidth() - (secondBleedWidth * 2 + bleedLineWidth),
            height: canvasSource.getHeight() - (secondBleedHeight * 2 + bleedLineWidth),
            fill: 'transparent',
            stroke: 'red',
            rx: filletRadius,
            ry: filletRadius,
            strokeWidth: 2,
            objType:'draggableDiecut',
            lockMovementX:true,
            lockMovementY:true,
            lockScalingFlip:true,
        });
        rect.setControlVisible('mtr', false);
        canvasSource.add(rect);
        canvasSource.setActiveObject(rect);
        canvasSource.renderAll();
        drawBleedCircleLine(false, bleedLineWidth, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
    }else if($('.choose-lines .active').find('button').attr('line-type') == 'circle'){
        let ellipse = new fabric.Ellipse({
            centeredScaling:true,
            rx: (canvasSource.getWidth() - (secondBleedWidth * 2 + bleedLineWidth)) / 2,
            ry: (canvasSource.getHeight() - (secondBleedHeight * 2 + bleedLineWidth)) / 2,
            fill: 'transparent',
            stroke: 'red',
            strokeWidth: 2,
            strokeDashArray: [5, 0],
            left: secondBleedWidth,
            top: secondBleedHeight,
            objType:'draggableDiecut',
            lockMovementX:true,
            lockMovementY:true,
            lockScalingFlip:true,
        });
        if(Math.round(canvasSource.getWidth()) == Math.round(canvasSource.getHeight())){
            ellipse.setControlsVisibility({
                mtr: false,
                ml: true,
                mt: true,
                mr: true,
                mb: true
            });
        }else{
            ellipse.setControlVisible({
                mtr: false,
                ml: true,
                mt: true,
                mr: true,
                mb: true
            });
        }
        canvasSource.add(ellipse);
        canvasSource.setActiveObject(ellipse);
        canvasSource.renderAll();
        drawBleedEllipseLine(false, secondBleedWidth, secondBleedHeight, secondBleedWidth, secondBleedHeight);
    }
}

// sure custom die
function sureDieCut(){
    if(!startDieCutFlag){
        return;
    }
    if(currentImgObj == ''){
        return
    }
    customerOpearationRecords(recordsParentId, 'sure draw dieCut', optstep++);
    if(inchSourceWidth == '' && inchSourceHeight == ''){
        inchSourceWidth = inchWidth;
        inchSourceHeight= inchHeight;
    }
    let diecutObj = '';
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'draggableDiecut'){
            diecutObj = canvasSource._objects[index];
        }
        if(canvasSource._objects[index].objType == 'image'){
            canvasSource._objects[index].evented = true;
            canvasSource._objects[index].selectable = true;
        }
    }
    if(!diecutObj){
        return;
    }
    let dieCutWidth = diecutObj.getScaledWidth();
    let dieCutHeight = diecutObj.getScaledHeight();
    let longInch =  Math.max(inchSourceWidth, inchSourceHeight);
    let shortInch =  Math.min(inchSourceWidth, inchSourceHeight);
    if(dieCutWidth > dieCutHeight){
        inchWidth = longInch;
        inchHeight = Math.round((dieCutHeight / dieCutWidth * inchWidth) * 10) / 10;
        if(inchHeight > shortInch){
            inchWidth = Math.round((shortInch / inchHeight * inchWidth) * 10) / 10;;
            inchHeight = shortInch;
        }
    }else{
        inchHeight = longInch;
        inchWidth = Math.round((dieCutWidth / dieCutHeight * inchHeight) * 10) / 10;
        if(inchWidth > shortInch){
            inchHeight =  Math.round((shortInch / inchWidth * inchHeight) * 10) / 10;
            inchWidth = shortInch;
        }
    }
    drawImageUrl = currentImgObj.getSrc()
    reloadImgObjs = {
        nocropImg:'',
        noclearImg:''
    }
    dieCutResultData = {
        data: null,
        clearData: null
    }
    $('.canvas-container').remove();
    lineType = $('.choose-lines .active').find('button').attr('line-type');
    // offset
    let imgOffsetLeft = currentImgObj.left - diecutObj.left;
    let imgOffsetTop = currentImgObj.top - diecutObj.top;

    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'draggableDiecut'){
            canvasSource._objects.splice(index,1);
            index--;
        }
    }
    // clear undoObjArr
    undoObjArr = [];
    $('.uploadPropTipDiy .Undo').css('display','none');

    // undoObjArr.unshift(canvasSource.toJSON());
    initCanvas(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType,
        true, imgOffsetLeft, imgOffsetTop, currentImgObj.getScaledWidth(), currentImgObj.getScaledHeight(), diecutObj.getScaledWidth(), diecutObj.getScaledHeight());

}

$('.uploadPropTipDiy .start-draw-diecut').on('click', function(){
    $('.stickers-cut-line-button-area').removeClass('stickers-cut-line-active').eq(1).addClass('stickers-cut-line-active');
    sureDieCut();
    // if($(this).hasClass('new-start-draw-diecut-active')){
    //     $('.new-start-draw-diecut').removeClass('new-start-draw-diecut-active')
    //     sureDieCut();
    // }else{
    //     $('.new-start-draw-diecut').addClass('new-start-draw-diecut-active')
    //     startDieCut();
    // }
})

// Design Content Preview
$(".uploadPropTipDiyDivLeft .previewDecal").on("click",function(params) {
    setCanvasSize(canvasSource.getWidth() * 2,canvasSource.getHeight() * 2, 2);
    let overlayImagePath = '';
    if(canvasSource.overlayImage){
        overlayImagePath = canvasSource.overlayImage.getSrc();
    }
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'bleedLine' || canvasSource._objects[index].isBG){
            canvasSource._objects[index].setVisible(false);
        }
    }
    canvasSource.renderAll();
    if(canvasSource.overlayImage){
        canvasSource.overlayImage.setVisible(false);
    }
    // canvasSource.setBackgroundColor("rgba(0,0,0,0)");
    canvasSource.renderAll();
    let pruePreviewPath=canvasSource.toDataURL({format: 'png'});

    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'bleedLine' || canvasSource._objects[index].isBG){
            canvasSource._objects[index].setVisible(true);
        }
    }
    if(canvasSource.overlayImage){
        canvasSource.overlayImage.setVisible(true);
    }
    //  canvasSource.setBackgroundColor("#ffffff");
    // setCanvasSize(1);
    setCanvasSize(canvasSource.getWidth() / 2,canvasSource.getHeight() / 2, 1);
    canvasSource.renderAll();
    if( productType == 'Decal' && lineType == 'dieCut') {
        let obj=canvasSource._objects[1];
        let groupRect = new fabric.Rect({
            width: obj.width,
            height: obj.height,
            left:-obj.width/2,
            top:-obj.height/2,
            fill: "#ffffff",
            globalCompositeOperation:"xor"
        })
        obj._objects.push(groupRect);
        obj._objects.filter(item=>item.id=="moqie")[0].setFill("#000000")
        canvasSource._objects[0].setVisible(false)
        canvasSource.setBackgroundColor("rgba(0,0,0,0)")
        canvasSource.renderAll()
        //let attUrl=obj.toDataURL();
        $(".preview-model").find(".preview-front-decals").remove();
        $decalsImg = $("<img class='preview-front-decals'>");
        $decalsImg.attr("src",canvasSource.toDataURL());
        $(".preview-model").append($decalsImg);
        obj._objects.filter(item=>item.id=="moqie")[0].setFill("")
        obj.remove(groupRect)
        canvasSource._objects[0].setVisible(true)
        canvasSource.setBackgroundColor("#ffffff")
        canvasSource.renderAll();
    }
    $(".sticker-preview-preview .preview-model").removeClass("preview-decals");
    if(productType == 'Decal'){
        $(".sticker-preview-preview .preview-model").addClass("preview-decals");
    }
    let canvasHideSource;
    let hideCanvasId = 'cas-hid';
    var existingHideCanvas = document.getElementById(hideCanvasId);
    if (!existingHideCanvas) {
        $('.uploadPropTipDiy .can-resource-hid').append('<canvas id="cas-hid" style="display:none"></canvas>');
        canvasHideSource = new fabric.Canvas(hideCanvasId);
    } else {
        canvasHideSource = new fabric.Canvas(existingHideCanvas);
        canvasHideSource.clear();
    }
    if(canvasSource.overlayImage){
        fabric.Image.fromURL(overlayImagePath,
            function (olimg) {
                olimg.scaleToWidth(canvasSource.getWidth());
                canvasHideSource.setWidth(canvasSource.getWidth());
                canvasHideSource.setHeight(canvasSource.getHeight());
                canvasHideSource.add(olimg)
                canvasHideSource.renderAll();
                fabric.Image.fromURL(pruePreviewPath,
                    function (ppimg) {
                        ppimg.scaleToWidth(canvasSource.getWidth());
                        ppimg.globalCompositeOperation="source-out";
                        canvasHideSource.add(ppimg)
                        canvasHideSource.renderAll();
                        $(".can-resource-hid,.can-resource-hid canvas").css("display","block");
                        setTimeout(function () {
                            if($(".sticker-preview .preview-model .preview-front-decals").length>0){
                                $(".preview-model").find(".preview-front-decals").remove();
                                $decalsImg = $("<img class='preview-front-decals'>");
                                $decalsImg.attr("src",canvasSource.overlayImage.getSrc());
                                $(".preview-model").append($decalsImg);
                                $(".sticker-preview .preview-model img:not('.preview-img'):not('.preview-front-decals')").attr("src",canvasHideSource.toDataURL({format: 'png'}));
                            }else{
                                $(".sticker-preview .preview-model img:not('.preview-img')").attr("src",canvasHideSource.toDataURL({format: 'png'}));
                            }
                            $(".can-resource-hid,.can-resource-hid canvas").css("display","none");
                            //$(".sticker-preview .preview-model img:not('.preview-img')").attr("src",canvasHideSource.toDataURL('png'));
                            $(".sticker-preview,.sticker-preview-preview").css('display','block');
                            $('.can-resource-hid .canvas-container').remove();
                            var newproductselectfirstchildSizeText=$('.newproductselectfirstchildSize').text()
                            if(productType=='WallDecal'){
                                let maximagewidth = 0, maximageheight = 0;
                                if(canvasHideSource.getWidth() > canvasHideSource.getHeight()){
                                    maximagewidth = $(".sticker-preview").outerWidth()/18*5;
                                    maximageheight = $(".sticker-preview").outerHeight()/12*5;
                                    maximageheight = canvasHideSource.getHeight() / (canvasHideSource.getWidth() / maximagewidth);
                                }else{
                                    maximagewidth = $(".sticker-preview").outerWidth()/9*2;
                                    maximageheight = $(".sticker-preview").outerHeight()/3;
                                    maximagewidth = canvasHideSource.getWidth() / (canvasHideSource.getHeight() / maximageheight);
                                }
                                $('.sticker-preview .preview-front-model').css('width', maximagewidth+'px');
                                $('.sticker-preview .preview-front-model').css('height',maximageheight+'px');
                                $('.sticker-preview .preview-front-model').css('left',(($('.preview-model').width() / 2 - ($(".sticker-preview .preview-model img:not('.preview-img')").width()) / 2) + $(".sticker-preview").outerWidth()/30) + 'px');
                                $('.sticker-preview .preview-front-model').css('top', (($('.preview-model').height() / 3 * 2 - ($(".sticker-preview .preview-model img:not('.preview-img')").height())) - $(".sticker-preview").outerHeight()/10) + 'px')
                            }else if(productType=='FloorDecals'){
                                let maximagewidth = $(".sticker-preview").outerWidth()/3, maximageheight = $(".sticker-preview").outerHeight()/2;
                                if(canvasHideSource.getWidth() > canvasHideSource.getHeight()){
                                    maximageheight = canvasHideSource.getHeight() / (canvasHideSource.getWidth() / maximagewidth);
                                }else{
                                    maximagewidth = canvasHideSource.getWidth() / (canvasHideSource.getHeight() / maximageheight);
                                }
                                $('.sticker-preview .preview-front-model').css('width', maximagewidth+'px');
                                $('.sticker-preview .preview-front-model').css('height',maximageheight+'px');
                                if(canvasSource.getWidth() > canvasSource.getHeight()){
                                    $('.sticker-preview .preview-front-model').css('left','21%')
                                    $('.sticker-preview .preview-front-model').css('bottom','20%')

                                }else{
                                    $('.sticker-preview .preview-front-model').css('left','30%')
                                    $('.sticker-preview .preview-front-model').css('bottom','0%')
                                }

                                $('.sticker-preview .preview-front-model').css('transform', 'rotateX(30deg) rotateY(-15deg) rotateZ(-10deg) skew(23deg, -5deg) translate(66px,-25px)')
                            }else if (productType=='Decal'){
                                $('.sticker-preview .preview-model .preview-img').css("position","absolute")
                                $('.sticker-preview .preview-model .preview-img').css("z-index","1")
                                $('.sticker-preview .preview-model .preview-front-model').css("position","absolute")
                                $('.sticker-preview .preview-model .preview-front-decals').css("position","absolute")
                                $('.sticker-preview .preview-model .preview-front-decals').css("z-index","2")
                            }
                        },10)

                    },
                    { crossOrigin: "anonymous" }
                );
            },
            { crossOrigin: "anonymous" }
        );
    }else{
        fabric.Image.fromURL(pruePreviewPath,
            function (ppimg) {
                ppimg.scaleToWidth(canvasSource.getWidth());
                canvasHideSource.setWidth(canvasSource.getWidth());
                canvasHideSource.setHeight(canvasSource.getHeight());
                canvasHideSource.add(ppimg)
                canvasHideSource.renderAll();
                $(".can-resource-hid,.can-resource-hid canvas").css("display","block");
                setTimeout(function () {
                    if($(".sticker-preview .preview-model .preview-front-decals").length>0){
                        $(".sticker-preview .preview-model img:not('.preview-img'):not('.preview-front-decals')").attr("src",canvasHideSource.toDataURL({format: 'png'}));
                    }else{
                        $(".sticker-preview .preview-model img:not('.preview-img')").attr("src",canvasHideSource.toDataURL({format: 'png'}));
                    }
                    $(".can-resource-hid,.can-resource-hid canvas").css("display","none");
                    //$(".sticker-preview .preview-model img:not('.preview-img')").attr("src",canvasHideSource.toDataURL('png'))
                    $(".sticker-preview,.sticker-preview-preview").css('display','block');
                    $('.can-resource-hid .canvas-container').remove();
                    var newproductselectfirstchildSizeText=$('.newproductselectfirstchildSize').text()
                    if(productType=='WallDecal'){
                        let maximagewidth = 0, maximageheight = 0;
                        if(canvasHideSource.getWidth() > canvasHideSource.getHeight()){
                            maximagewidth = 250;
                            maximageheight = 250;
                            maximageheight = canvasHideSource.getHeight() / (canvasHideSource.getWidth() / maximagewidth);
                        }else{
                            maximagewidth = 200;
                            maximageheight = 200;
                            maximagewidth = canvasHideSource.getWidth() / (canvasHideSource.getHeight() / maximageheight);
                        }
                        $('.sticker-preview .preview-front-model').css('width', maximagewidth+'px');
                        $('.sticker-preview .preview-front-model').css('height',maximageheight+'px');
                        $('.sticker-preview .preview-front-model').css('left',(($('.preview-model').width() / 2 - ($(".sticker-preview .preview-model img:not('.preview-img')").width()) / 2) + 30) + 'px');
                        $('.sticker-preview .preview-front-model').css('top', (($('.preview-model').height() / 3 * 2 - ($(".sticker-preview .preview-model img:not('.preview-img')").height())) - 60) + 'px')
                    }else if(productType=='FloorDecals'){
                        let maximagewidth = 300, maximageheight = 300;
                        if(canvasHideSource.getWidth() > canvasHideSource.getHeight()){
                            maximageheight = canvasHideSource.getHeight() / (canvasHideSource.getWidth() / maximagewidth);
                        }else{
                            maximagewidth = canvasHideSource.getWidth() / (canvasHideSource.getHeight() / maximageheight);
                        }
                        $('.sticker-preview .preview-front-model').css('width', maximagewidth+'px');
                        $('.sticker-preview .preview-front-model').css('height',maximageheight+'px');
                        if(canvasSource.getWidth() > canvasSource.getHeight()){
                            $('.sticker-preview .preview-front-model').css('left','21%')
                            $('.sticker-preview .preview-front-model').css('bottom','20%')
                        }else{
                            $('.sticker-preview .preview-front-model').css('left','30%')
                            $('.sticker-preview .preview-front-model').css('bottom','0%')
                        }

                        $('.sticker-preview .preview-front-model').css('transform', 'rotateX(30deg) rotateY(-15deg) rotateZ(-10deg) skew(23deg, -5deg) translate(66px,-25px)')
                    } else if (productType=='Decal'){
                        $('.sticker-preview .preview-model .preview-img').css("position","absolute")
                        $('.sticker-preview .preview-model .preview-img').css("z-index","1")
                        $('.sticker-preview .preview-model .preview-front-model').css("position","absolute")
                        $('.sticker-preview .preview-model .preview-front-decals').css("position","absolute")
                        $('.sticker-preview .preview-model .preview-front-decals').css("z-index","2")
                    }
                },10)
            },
            { crossOrigin: "anonymous" }
        );
    }


})
//Close Design Content Preview
$(".sticker-preview .closePreview").on("click",function(params) {
    $(".sticker-preview, .sticker-preview-preview").css('display','none');
})

function ContinueAddCart(){
    $('#ContinueFunzId1').css('display','none')
    $('.ContinueFunzId1Button').css('display','block')
    var istrue=false
    $('.cartreloads').find('p').text('Create file...');
    $('.cartreloads').css('display','block');
    $('#createDesign').css('pointer-events','none')

    // NOT JPRG JPG PNG
    if($(".product-submite-tip").is(":visible")){
        $('.cartreloads').find('p').text('Add to cart...');
        $('.uploadImgidrema').val($('.uploadProp3TextareaDiy').val())
        $('#createDesign').css('pointer-events', 'initial')
        // $('.Continue').click()
        if (isdiy && isaddcart) {
            isContinueFunz=true
            istrue=ContinueFunzBig(1)
        } else {
            $('#ContinueFunzId1').css('display','block')
            $('.ContinueFunzId1Button').css('display','none')
            isContinueFunz=true
            tipShow('Please select a file')
        }
    }else {
        if(lineType=='dieCut' && !(UploadProductType.UploadProductType.name == 'labels$keychains' || UploadProductType.UploadProductType.name == 'labels$acrylicStand')){
            if(isContinueFunz){
                isContinueFunz = false
                istrue = saveDieCut()
                isContinueFunz = true
                if(istrue){
                    istrue=ContinueFunzBig(1)
                }
            }
            $('.cartreloads').css('display','none')
            return istrue
        }

        let workScale = (workAreaWidth * 72 / 25.4) / canvasSource.getWidth();
        for (let index = 0; index < canvasSource._objects.length; index++) {
            if(canvasSource._objects[index].objType == 'image'){
                currentImgObj = canvasSource._objects[index];
            }
        }
        if(currentImgObj && currentImgObj != ''){
            let normalImageUrl = '';
            if(drawImageUrl.indexOf('!')!= -1){
                normalImageUrl = drawImageUrl.split('!')[0];
            }else{
                normalImageUrl = drawImageUrl.replace('/large/', '/normal/');
            }
            for (let index = 0; index < canvasSource._objects.length; index++) {
                if(canvasSource._objects[index].objType == 'bleedLine'){
                    canvasSource._objects[index].visable=false;
                }
            }
            canvasSource.renderAll();
            customerOpearationRecords(recordsParentId, 'Add to cart', optstep++);
            let data = {
                uniqueId:uniqueId,
                pdfWidth:workAreaWidth,
                pdfHeight:workAreaHeight,
                drawImageUrl:drawImageUrl,
                drawImageWidth: currentImgObj.getScaledWidth() * workScale,
                drawImageHeight: currentImgObj.getScaledHeight() * workScale,
                drawImageLeft: currentImgObj.getLeft() * workScale,
                drawImageTop: (canvasSource.getHeight() - (currentImgObj.getTop() + currentImgObj.getScaledHeight())) * workScale, // itext->
                normalImageUrl: normalImageUrl,
                normalImageWidth: imgFactWidth,
                normalImageHeight: imgFactHeight,
                circlesticker:circlesticker,
                uploadPreview:canvasSource.toDataURL(),
                singleDieCut: true,
                acrylicApi: 'V2',
            };
            if(productType == 'sticker'){
                data.singleDieCut = false;
            }
            if(canvasSource.backgroundColor != 'white'){
                data.canvasBgColor=colorDecimal(canvasSource.backgroundColor)
            }
            // Acrylic keychain and signboard - find the edge
            if(UploadProductType.UploadProductType.name.indexOf('labels$') != -1){
                // Acrylic find the edge results
                if(acrylicDieCutSvg != ''){
                    data.acrylicDieCutSvg = acrylicDieCutSvg;
                }
                if(JSON.stringify(custMoQie) != '{}'){
                    let cx = (custMoQie.cx / diyWorkAreaHeight * workAreaHeight);
                    let cy = (custMoQie.cy / diyWorkAreaHeight * workAreaHeight);
                    let r = (custMoQie.r / diyWorkAreaHeight * workAreaHeight);
                    custMoQie.cx = cx
                    custMoQie.cy = cy
                    custMoQie.r = r
                    // Keychain drilling position
                    data.custMoQie = custMoQie;
                }
                let acrylicType = UploadProductType.UploadProductType.name.replace('labels$','');
                data.acrylicType = acrylicType;
                data.diyWorkAreaHeight = diyWorkAreaHeight;
                data.diyWorkAreaWidth = diyWorkAreaWidth;
            }
            var istrue=false
            if(isContinueFunz){
                isContinueFunz=false
                $.ajax({
                    url: "https://diy.racetopprint.com/diyWeb/csrdiy/addImageToPdf_hwzByGuonei.do",
                    // url: "https://diy.racetopprint.com/diyWeb/csrdiy/addImageToPdf_hwz_product.do",
                    // url: "https://diy.36588.com.cn/diyWeb/csrdiy/addImageToPdf_hwz.do",
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    async:false,
                    success: function(res) {
                        if (res.success) {
                            $('.cartreloads').find('p').text('Add to cart...');
                            $('.uploadImgidrema').val($('.uploadProp3TextareaDiy').val())
                            if(res.message && res.message != ''){
                                $('.designUpload').attr('src',res.message);
                            }else{
                                $('.designUpload').attr('src',currentImgObj.getSrc());
                            }
                            $('#createDesign').css('pointer-events', 'initial')
                            // $('.Continue').click()
                            if (isdiy && isaddcart) {
                                isContinueFunz=true
                                istrue=ContinueFunzBig(1)
                            } else {
                                $('#ContinueFunzId1').css('display','block')
                                $('.ContinueFunzId1Button').css('display','none')
                                isContinueFunz=true
                                tipShow('Please select a file')
                            }
                        } else {
                            $('.cartreloads').css('display','none');
                            $('#ContinueFunzId1').css('display','block')
                            $('.ContinueFunzId1Button').css('display','none')
                            isContinueFunz=true
                            tipShow('Failed to add shopping cart. Please refresh the page and try again')
                        }
                    },
                    error: function(error) {

                    }
                });
            }
        }else{
            $('.designUpload').attr('src', '');
            $('.cartreloads').find('p').text('Add to cart...');
            $('.uploadImgidrema').val($('.uploadProp3TextareaDiy').val())
            $('.cartreloads').css('display','none');
            $('#createDesign').css('pointer-events', 'initial')
            isContinueFunz=true
            istrue=ContinueFunzBig(1)
        }
    }
    return istrue
}
/*********** Upload File start **************/
function ContinueFunz1(){
    if (window.reportGoogleAdsAddToCart) {
        var priceDom = document.querySelector('.newproductselectdivQuantity .active .newproductselectdivQuantityp');
        var price = 0;
        if (priceDom) {
            price = priceDom.innerText.match(/\d+(.\d+)?/) && priceDom.innerText.match(/\d+(.\d+)?/)[0] || 0;
        }
        window.reportGoogleAdsAddToCart(price, Shopify.currency.active || 'USD');
    }
    var istrue=false
    // Add to Cart cannot be async
    // if(startDieCutFlag){
    //     $('.uploadPropTipDiy .start-draw-diecut').trigger('click');
    //     var t1=window.setInterval(function(){
    //         if(!startDieCutFlag){
    //             window.clearInterval(t1);
    //             istrue = ContinueAddCart();
    //             return istrue;
    //         }
    //     }, 200)
    // }else{
    istrue = ContinueAddCart();
    return istrue;
    // }
}

/*********** Upload File end**************/

let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
//RGB to 16
let colorHex = function(valueStr){
    if(/^(rgb|RGB)/.test(valueStr)){
        var aColor = valueStr.replace(/(?:\(|\)|rgb|RGB)*/g,"").split(",");
        var strHex = "#";
        for(var i=0;i<aColor.length;i++){
            var hex = Number(aColor[i]).toString(16);
            if(hex === "0"){
                hex += hex;
            }
            if(hex.length<2) hex = "0"+hex;
            strHex += hex;
        }

        if(strHex.length !== 7){
            strHex = valueStr;
        }
        return strHex;
    } else if(reg.test(valueStr)){
        var aNum = valueStr.replace(/#/,"").split("");
        if(aNum.length === 6){
            return valueStr
        }else if(aNum.length === 3){
            var numHex ="#";
            for(var i=0;i<aNum.length;i+=1){
                numHex += (aNum[i]+aNum[i]);
            }
            return numHex
        }
    }else{
        return valueStr
    }
}
//16 to ten
let colorDecimal = function(valueStr){
    //console.log(valueStr);
    var colorValue
    if(valueStr.indexOf('#')!=-1){
        var arr = valueStr.split("#")
        var str = arr[1];
        colorValue = parseInt(str,16);
    }
    else
    {
        colorValue = parseInt(str,16);
    }
    return colorValue

}
